var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 250,
    viewBox: "0 0 350 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H340C345.523 0 350 4.47715 350 10V250H0V10Z",
    fill: "#EFF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.019 169.783L169.64 201.989",
    stroke: "#0B54AC",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.297 208.116L237.207 181.81",
    stroke: "#0B54AC",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.422 151.763L210.971 97.5708",
    stroke: "#0B54AC",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.053 93.813L261.046 180.351",
    stroke: "#0B54AC",
    strokeWidth: 1.8707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.666 122.366L175.117 149.419C172.951 150.676 169.436 150.676 167.253 149.419L120.397 122.366C119.303 121.735 118.753 120.901 118.753 120.073L118.729 127.624C118.729 128.452 119.274 129.286 120.374 129.917L167.23 156.97C169.407 158.226 172.928 158.226 175.093 156.97L221.642 129.917C222.719 129.292 223.258 128.475 223.258 127.659L223.281 120.108C223.281 120.919 222.743 121.741 221.666 122.366Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.642 117.81C223.82 119.066 223.831 121.104 221.665 122.361L175.116 149.414C172.951 150.67 169.436 150.67 167.253 149.414L120.397 122.361C118.22 121.104 118.208 119.066 120.374 117.81L166.923 90.7568C169.089 89.5003 172.603 89.5003 174.786 90.7568L221.642 117.81Z",
    fill: "#82BDF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.344 119.702L174.503 139.951C172.882 140.895 170.247 140.895 168.62 139.951L133.548 119.702C132.725 119.227 132.314 118.607 132.32 117.988L132.303 121.068C132.303 121.688 132.708 122.313 133.53 122.782L168.603 143.031C170.236 143.975 172.87 143.975 174.486 143.031L209.327 122.782C210.132 122.313 210.537 121.705 210.537 121.091L210.554 118.011C210.554 118.619 210.149 119.233 209.344 119.702Z",
    fill: "#172C7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.327 116.292C210.96 117.236 210.966 118.759 209.345 119.702L174.504 139.952C172.883 140.895 170.248 140.895 168.621 139.952L133.548 119.702C131.915 118.759 131.91 117.236 133.531 116.292L168.372 96.0428C169.993 95.099 172.628 95.099 174.255 96.0428L209.327 116.292Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.35 121.382C157.969 121.201 157.551 121.131 157.097 121.171C156.644 121.21 156.193 121.359 155.745 121.618C155.441 121.794 155.227 121.967 155.104 122.138C154.978 122.307 154.933 122.467 154.971 122.617C155.011 122.767 155.126 122.896 155.315 123.005C155.467 123.1 155.638 123.16 155.827 123.187C156.02 123.211 156.223 123.211 156.439 123.187C156.651 123.16 156.874 123.116 157.106 123.055C157.336 122.992 157.568 122.917 157.804 122.831L158.785 122.483C159.256 122.311 159.724 122.173 160.189 122.07C160.654 121.968 161.109 121.909 161.554 121.894C161.998 121.879 162.428 121.916 162.841 122.006C163.257 122.094 163.65 122.243 164.021 122.453C164.557 122.766 164.887 123.116 165.011 123.502C165.134 123.885 165.05 124.287 164.757 124.708C164.464 125.126 163.959 125.542 163.241 125.956C162.53 126.367 161.8 126.662 161.054 126.841C160.311 127.018 159.577 127.069 158.854 126.992C158.131 126.913 157.445 126.694 156.796 126.336L158.6 125.295C158.916 125.454 159.247 125.547 159.595 125.576C159.942 125.6 160.292 125.569 160.645 125.481C160.998 125.39 161.335 125.252 161.657 125.066C161.973 124.884 162.201 124.699 162.341 124.512C162.485 124.323 162.54 124.144 162.505 123.975C162.471 123.806 162.347 123.66 162.135 123.537C161.937 123.423 161.711 123.361 161.459 123.351C161.209 123.339 160.925 123.371 160.606 123.445C160.291 123.518 159.933 123.625 159.534 123.766L158.333 124.181C157.409 124.506 156.539 124.681 155.724 124.708C154.909 124.734 154.177 124.559 153.528 124.181C152.991 123.874 152.667 123.523 152.555 123.127C152.446 122.729 152.532 122.32 152.813 121.899C153.095 121.478 153.557 121.082 154.2 120.711C154.854 120.333 155.537 120.068 156.249 119.915C156.964 119.761 157.657 119.72 158.329 119.793C159 119.866 159.603 120.052 160.137 120.35L158.35 121.382ZM169.769 122.187C169.348 122.43 168.898 122.605 168.422 122.711C167.943 122.816 167.462 122.84 166.98 122.783C166.497 122.724 166.038 122.568 165.602 122.316C165.234 122.104 164.993 121.887 164.878 121.665C164.764 121.442 164.746 121.22 164.827 120.998C164.907 120.776 165.056 120.558 165.275 120.342C165.496 120.125 165.754 119.913 166.05 119.706C166.394 119.46 166.667 119.26 166.868 119.104C167.066 118.947 167.182 118.817 167.216 118.714C167.251 118.611 167.198 118.519 167.057 118.438L167.031 118.423C166.758 118.266 166.461 118.193 166.14 118.207C165.821 118.218 165.506 118.314 165.193 118.495C164.863 118.686 164.673 118.88 164.624 119.077C164.573 119.272 164.624 119.451 164.779 119.614L162.945 120.514C162.63 120.232 162.452 119.934 162.411 119.619C162.368 119.302 162.467 118.983 162.708 118.662C162.95 118.337 163.334 118.022 163.862 117.717C164.23 117.505 164.624 117.327 165.046 117.183C165.471 117.037 165.905 116.941 166.347 116.894C166.791 116.846 167.232 116.86 167.668 116.936C168.102 117.011 168.515 117.162 168.908 117.389L173.369 119.964L171.629 120.968L170.712 120.439L170.661 120.469C170.761 120.649 170.801 120.837 170.781 121.031C170.758 121.223 170.666 121.417 170.506 121.612C170.342 121.806 170.097 121.998 169.769 122.187ZM169.029 121.152C169.299 120.997 169.484 120.828 169.584 120.648C169.682 120.465 169.698 120.287 169.632 120.113C169.566 119.939 169.416 119.785 169.184 119.651L168.482 119.246C168.462 119.3 168.418 119.366 168.349 119.442C168.28 119.515 168.197 119.595 168.099 119.681C167.998 119.765 167.897 119.849 167.793 119.932C167.687 120.013 167.591 120.087 167.505 120.153C167.321 120.296 167.183 120.433 167.091 120.566C167 120.698 166.968 120.824 166.997 120.944C167.023 121.061 167.122 121.17 167.294 121.269C167.544 121.413 167.825 121.471 168.138 121.443C168.451 121.412 168.748 121.315 169.029 121.152ZM176.802 118.126C176.381 118.369 175.931 118.544 175.455 118.65C174.975 118.755 174.495 118.779 174.013 118.722C173.53 118.663 173.071 118.507 172.635 118.255C172.267 118.043 172.026 117.826 171.911 117.604C171.797 117.382 171.779 117.16 171.86 116.938C171.94 116.716 172.089 116.497 172.308 116.281C172.529 116.064 172.787 115.852 173.083 115.645C173.427 115.4 173.7 115.199 173.901 115.043C174.099 114.886 174.215 114.756 174.249 114.653C174.284 114.55 174.231 114.458 174.09 114.377L174.064 114.362C173.791 114.205 173.494 114.133 173.173 114.146C172.854 114.158 172.539 114.254 172.226 114.434C171.896 114.625 171.706 114.819 171.657 115.016C171.606 115.212 171.657 115.391 171.812 115.553L169.978 116.453C169.663 116.171 169.485 115.873 169.444 115.558C169.401 115.241 169.5 114.922 169.741 114.601C169.983 114.276 170.367 113.961 170.895 113.656C171.263 113.444 171.657 113.266 172.079 113.122C172.504 112.976 172.938 112.88 173.38 112.833C173.824 112.785 174.265 112.799 174.701 112.876C175.135 112.95 175.548 113.101 175.941 113.328L180.402 115.903L178.662 116.908L177.745 116.378L177.694 116.408C177.794 116.589 177.834 116.776 177.814 116.97C177.791 117.162 177.699 117.356 177.539 117.552C177.375 117.745 177.13 117.937 176.802 118.126ZM176.062 117.092C176.332 116.936 176.517 116.768 176.617 116.587C176.715 116.405 176.731 116.227 176.665 116.053C176.599 115.879 176.449 115.724 176.217 115.59L175.515 115.185C175.495 115.24 175.451 115.305 175.382 115.381C175.313 115.454 175.229 115.534 175.132 115.62C175.031 115.705 174.93 115.788 174.826 115.871C174.72 115.952 174.624 116.026 174.538 116.092C174.354 116.235 174.216 116.372 174.124 116.505C174.033 116.638 174.001 116.764 174.03 116.883C174.056 117.001 174.155 117.109 174.327 117.209C174.577 117.353 174.858 117.411 175.171 117.383C175.484 117.351 175.781 117.254 176.062 117.092ZM180.361 108.673C179.979 108.493 179.561 108.422 179.108 108.462C178.654 108.502 178.204 108.651 177.756 108.909C177.452 109.085 177.238 109.258 177.115 109.429C176.988 109.598 176.944 109.758 176.981 109.909C177.021 110.058 177.136 110.187 177.326 110.297C177.478 110.391 177.648 110.451 177.838 110.478C178.03 110.503 178.234 110.503 178.449 110.478C178.662 110.451 178.884 110.408 179.117 110.346C179.346 110.283 179.579 110.209 179.814 110.122L180.796 109.774C181.266 109.602 181.734 109.465 182.199 109.362C182.664 109.259 183.119 109.2 183.564 109.185C184.009 109.17 184.438 109.208 184.851 109.297C185.268 109.385 185.661 109.534 186.031 109.745C186.568 110.058 186.898 110.407 187.021 110.794C187.145 111.176 187.06 111.578 186.767 111.999C186.475 112.417 185.969 112.833 185.252 113.247C184.54 113.658 183.811 113.953 183.065 114.132C182.321 114.31 181.588 114.36 180.865 114.284C180.141 114.204 179.455 113.986 178.807 113.628L180.611 112.586C180.926 112.745 181.258 112.839 181.605 112.867C181.952 112.892 182.303 112.86 182.656 112.772C183.009 112.681 183.346 112.543 183.667 112.357C183.983 112.175 184.211 111.99 184.352 111.803C184.496 111.614 184.55 111.435 184.516 111.266C184.481 111.097 184.358 110.951 184.145 110.828C183.947 110.714 183.722 110.652 183.469 110.642C183.22 110.63 182.936 110.662 182.617 110.736C182.301 110.809 181.944 110.916 181.545 111.057L180.344 111.472C179.419 111.797 178.55 111.973 177.735 111.999C176.919 112.026 176.187 111.85 175.539 111.472C175.002 111.166 174.678 110.814 174.566 110.418C174.457 110.021 174.543 109.611 174.824 109.19C175.105 108.769 175.567 108.373 176.21 108.002C176.865 107.624 177.548 107.359 178.26 107.207C178.974 107.052 179.668 107.012 180.339 107.085C181.011 107.158 181.614 107.343 182.148 107.642L180.361 108.673Z",
    fill: "#EF069A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 74.5938L106.065 95.7114L69.4932 74.5938L105.828 53.4819L142.4 74.5938Z",
    fill: "#82BDF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.402 74.5952L142.355 91.9143L106.021 113.032L106.067 95.7128L142.402 74.5952Z",
    fill: "#E3EBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.126 83.7041L107.267 96.4025L107.227 110.942L129.126 98.2149V83.7041Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.127 83.1188V97.6295L141.152 91.2253L141.192 76.6914L130.127 83.1188Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.066 95.7124L106.019 113.031L69.4473 91.9196L69.4936 74.5947L106.066 95.7124Z",
    fill: "#1687CD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.555 95.6245L110.599 98.485V99.1625L115.555 96.2962V95.6245Z",
    fill: "#BDDDFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 93.6558L115.845 95.4566V96.1341L118.966 94.3274V93.6558Z",
    fill: "#BDDDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.119 90.6797L119.255 93.488V94.1655L124.119 91.3514V90.6797Z",
    fill: "#BDDDFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.409 90.5114V91.1831L125.312 90.6619V89.9902L124.409 90.5114Z",
    fill: "#BDDDFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.268 99.44C113.268 99.4284 113.268 99.4169 113.274 99.4053L110.599 100.951V101.623L113.268 100.083V99.44Z",
    fill: "#BDDDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 99.237C113.551 99.2485 113.551 99.2601 113.551 99.2717V99.9144L120.783 95.7396V95.0679L113.551 99.237Z",
    fill: "#BDDDFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.073 94.8947V95.5722L125.312 93.1229V92.4512L121.073 94.8947Z",
    fill: "#BDDDFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.61 99.3589L116.11 100.222V100.893L117.61 100.031V99.3589Z",
    fill: "#BDDDFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.895 99.1912V99.8687L125.312 95.5838V94.9121L117.895 99.1912Z",
    fill: "#BDDDFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.827 100.39L110.599 103.406V104.084L115.827 101.061V100.39Z",
    fill: "#BDDDFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M121.873 99.3589L110.599 105.867V106.539L121.867 100.031C121.867 99.8105 121.873 99.5847 121.873 99.3589Z",
    fill: "#BDDDFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 99.1917C122.156 99.4175 122.15 99.6434 122.15 99.8692L125.312 98.0452V97.3735L122.156 99.1917Z",
    fill: "#BDDDFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 85.8162C133.165 86.0536 132.997 86.3373 132.794 86.4589C132.592 86.5747 132.424 86.4821 132.424 86.2446C132.424 86.0072 132.592 85.7235 132.794 85.6019C133.003 85.4861 133.165 85.5845 133.165 85.8162Z",
    fill: "#BDDDFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 84.6008C135.272 84.8382 135.105 85.122 134.902 85.2436C134.699 85.3594 134.531 85.2667 134.531 85.0293C134.531 84.7919 134.699 84.5082 134.902 84.3866C135.105 84.2708 135.272 84.3692 135.272 84.6008Z",
    fill: "#BDDDFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 83.3845C137.381 83.6219 137.213 83.9056 137.01 84.0272C136.808 84.1431 136.64 84.0504 136.64 83.813C136.64 83.5756 136.808 83.2919 137.01 83.1703C137.213 83.0545 137.381 83.1529 137.381 83.3845Z",
    fill: "#BDDDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 82.1682C139.488 82.4056 139.32 82.6893 139.118 82.8109C138.915 82.9268 138.747 82.8341 138.747 82.5967C138.747 82.3593 138.915 82.0756 139.118 81.954C139.32 81.8382 139.488 81.9366 139.488 82.1682Z",
    fill: "#BDDDFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 88.1097C133.165 88.3471 132.997 88.6308 132.794 88.7524C132.592 88.8682 132.424 88.7756 132.424 88.5382C132.424 88.3007 132.592 88.017 132.794 87.8954C133.003 87.7796 133.165 87.8723 133.165 88.1097Z",
    fill: "#BDDDFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 86.8934C135.272 87.1308 135.105 87.4145 134.902 87.5361C134.699 87.6519 134.531 87.5593 134.531 87.3218C134.531 87.0844 134.699 86.8007 134.902 86.6791C135.105 86.5633 135.272 86.6559 135.272 86.8934Z",
    fill: "#BDDDFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 85.6775C137.381 85.9149 137.213 86.1987 137.01 86.3203C136.808 86.4361 136.64 86.3434 136.64 86.106C136.64 85.8686 136.808 85.5849 137.01 85.4633C137.213 85.3475 137.381 85.4401 137.381 85.6775Z",
    fill: "#BDDDFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 84.4617C139.488 84.6991 139.32 84.9828 139.118 85.1044C138.915 85.2203 138.747 85.1276 138.747 84.8902C138.747 84.6528 138.915 84.3691 139.118 84.2475C139.32 84.1317 139.488 84.2243 139.488 84.4617Z",
    fill: "#BDDDFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 90.4021C133.165 90.6396 132.997 90.9233 132.794 91.0449C132.592 91.1607 132.424 91.068 132.424 90.8306C132.424 90.5932 132.592 90.3095 132.794 90.1879C133.003 90.0721 133.165 90.1647 133.165 90.4021Z",
    fill: "#BDDDFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 89.1863C135.272 89.4237 135.105 89.7075 134.902 89.8291C134.699 89.9449 134.531 89.8522 134.531 89.6148C134.531 89.3774 134.699 89.0937 134.902 88.9721C135.105 88.8563 135.272 88.9489 135.272 89.1863Z",
    fill: "#BDDDFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 87.97C137.381 88.2074 137.213 88.4911 137.01 88.6127C136.808 88.7286 136.64 88.6359 136.64 88.3985C136.64 88.1611 136.808 87.8774 137.01 87.7558C137.213 87.64 137.381 87.7326 137.381 87.97Z",
    fill: "#BDDDFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 86.7542C139.488 86.9916 139.32 87.2753 139.118 87.3969C138.915 87.5127 138.747 87.4201 138.747 87.1827C138.747 86.9453 138.915 86.6615 139.118 86.5399C139.32 86.4241 139.488 86.5168 139.488 86.7542Z",
    fill: "#BDDDFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 92.6892C133.165 92.9267 132.997 93.2104 132.794 93.332C132.592 93.4478 132.424 93.3551 132.424 93.1177C132.424 92.8803 132.592 92.5966 132.794 92.475C133.003 92.3592 133.165 92.4518 133.165 92.6892Z",
    fill: "#BDDDFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 91.4734C135.272 91.7108 135.105 91.9946 134.902 92.1162C134.699 92.232 134.531 92.1393 134.531 91.9019C134.531 91.6645 134.699 91.3808 134.902 91.2592C135.105 91.1434 135.272 91.236 135.272 91.4734Z",
    fill: "#BDDDFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 90.2576C137.381 90.495 137.213 90.7787 137.01 90.9003C136.808 91.0162 136.64 90.9235 136.64 90.6861C136.64 90.4487 136.808 90.165 137.01 90.0434C137.213 89.9276 137.381 90.0202 137.381 90.2576Z",
    fill: "#BDDDFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 89.0418C139.488 89.2792 139.32 89.5629 139.118 89.6845C138.915 89.8003 138.747 89.7077 138.747 89.4703C138.747 89.2329 138.915 88.9491 139.118 88.8275C139.32 88.7117 139.488 88.8044 139.488 89.0418Z",
    fill: "#BDDDFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M137.584 59.8642L106.05 78.1851L74.3125 59.8642L105.847 41.5376L137.584 59.8642Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M137.583 59.8643L137.537 74.8962L106.002 93.217L106.048 78.1851L137.583 59.8643Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M106.049 78.1851L106.003 93.217L74.2656 74.8962L74.3119 59.8643L106.049 78.1851Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 51.8511L106.065 72.9687L69.4932 51.8569L105.828 30.7393L142.4 51.8511Z",
    fill: "#82BDF9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M142.402 51.8501L142.355 69.175L106.021 90.2868L106.067 72.9677L142.402 51.8501Z",
    fill: "#E3EBFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 60.9585L107.266 73.6627L107.226 88.1966L129.125 75.4693V60.9585Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.126 60.3789V74.8839L141.151 68.4797L141.191 53.9458L130.126 60.3789Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.066 72.9683L106.019 90.2874L69.4473 69.1756L69.4936 51.8564L106.066 72.9683Z",
    fill: "#1687CD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M115.555 72.6245L110.599 75.485V76.1625L115.555 73.2962V72.6245Z",
    fill: "#BDDDFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 70.6558L115.845 72.4566V73.1341L118.966 71.3274V70.6558Z",
    fill: "#BDDDFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M124.119 67.6797L119.255 70.488V71.1655L124.119 68.3514V67.6797Z",
    fill: "#BDDDFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.409 67.5114V68.1831L125.312 67.6619V66.9902L124.409 67.5114Z",
    fill: "#BDDDFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M113.268 76.44C113.268 76.4284 113.268 76.4169 113.274 76.4053L110.599 77.9513V78.623L113.268 77.0828V76.44Z",
    fill: "#BDDDFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 76.237C113.551 76.2485 113.551 76.2601 113.551 76.2717V76.9144L120.783 72.7396V72.0679L113.551 76.237Z",
    fill: "#BDDDFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M121.073 71.8947V72.5722L125.312 70.1229V69.4512L121.073 71.8947Z",
    fill: "#BDDDFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M117.61 76.3589L116.11 77.2217V77.8934L117.61 77.0306V76.3589Z",
    fill: "#BDDDFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M117.895 76.1912V76.8687L125.312 72.5838V71.9121L117.895 76.1912Z",
    fill: "#BDDDFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.827 77.3896L110.599 80.4065V81.0839L115.827 78.0613V77.3896Z",
    fill: "#BDDDFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.873 76.3589L110.599 82.8673V83.539L121.867 77.0306C121.867 76.8105 121.873 76.5847 121.873 76.3589Z",
    fill: "#BDDDFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 76.1917C122.156 76.4175 122.15 76.6434 122.15 76.8692L125.312 75.0452V74.3735L122.156 76.1917Z",
    fill: "#BDDDFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 62.8162C133.165 63.0536 132.997 63.3373 132.794 63.4589C132.592 63.5747 132.424 63.4821 132.424 63.2446C132.424 63.0072 132.592 62.7235 132.794 62.6019C133.003 62.4861 133.165 62.5845 133.165 62.8162Z",
    fill: "#BDDDFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 61.6008C135.272 61.8382 135.105 62.122 134.902 62.2436C134.699 62.3594 134.531 62.2667 134.531 62.0293C134.531 61.7919 134.699 61.5082 134.902 61.3866C135.105 61.2708 135.272 61.3692 135.272 61.6008Z",
    fill: "#BDDDFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 60.3845C137.381 60.6219 137.213 60.9056 137.01 61.0272C136.808 61.1431 136.64 61.0504 136.64 60.813C136.64 60.5756 136.808 60.2919 137.01 60.1703C137.213 60.0545 137.381 60.1529 137.381 60.3845Z",
    fill: "#BDDDFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 59.1682C139.488 59.4056 139.32 59.6893 139.118 59.8109C138.915 59.9268 138.747 59.8341 138.747 59.5967C138.747 59.3593 138.915 59.0756 139.118 58.954C139.32 58.8382 139.488 58.9366 139.488 59.1682Z",
    fill: "#BDDDFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 65.1097C133.165 65.3471 132.997 65.6308 132.794 65.7524C132.592 65.8682 132.424 65.7756 132.424 65.5382C132.424 65.3007 132.592 65.017 132.794 64.8954C133.003 64.7796 133.165 64.8723 133.165 65.1097Z",
    fill: "#BDDDFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 63.8934C135.272 64.1308 135.105 64.4145 134.902 64.5361C134.699 64.6519 134.531 64.5593 134.531 64.3218C134.531 64.0844 134.699 63.8007 134.902 63.6791C135.105 63.5633 135.272 63.6559 135.272 63.8934Z",
    fill: "#BDDDFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 62.6775C137.381 62.9149 137.213 63.1987 137.01 63.3203C136.808 63.4361 136.64 63.3434 136.64 63.106C136.64 62.8686 136.808 62.5849 137.01 62.4633C137.213 62.3475 137.381 62.4401 137.381 62.6775Z",
    fill: "#BDDDFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 61.4617C139.488 61.6991 139.32 61.9828 139.118 62.1044C138.915 62.2203 138.747 62.1276 138.747 61.8902C138.747 61.6528 138.915 61.3691 139.118 61.2475C139.32 61.1317 139.488 61.2243 139.488 61.4617Z",
    fill: "#BDDDFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 67.4021C133.165 67.6396 132.997 67.9233 132.794 68.0449C132.592 68.1607 132.424 68.068 132.424 67.8306C132.424 67.5932 132.592 67.3095 132.794 67.1879C133.003 67.0721 133.165 67.1647 133.165 67.4021Z",
    fill: "#BDDDFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 66.1863C135.272 66.4237 135.105 66.7075 134.902 66.8291C134.699 66.9449 134.531 66.8522 134.531 66.6148C134.531 66.3774 134.699 66.0937 134.902 65.9721C135.105 65.8563 135.272 65.9489 135.272 66.1863Z",
    fill: "#BDDDFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 64.97C137.381 65.2074 137.213 65.4911 137.01 65.6127C136.808 65.7286 136.64 65.6359 136.64 65.3985C136.64 65.1611 136.808 64.8774 137.01 64.7558C137.213 64.64 137.381 64.7326 137.381 64.97Z",
    fill: "#BDDDFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 63.7542C139.488 63.9916 139.32 64.2753 139.118 64.3969C138.915 64.5127 138.747 64.4201 138.747 64.1827C138.747 63.9453 138.915 63.6615 139.118 63.5399C139.32 63.4241 139.488 63.5168 139.488 63.7542Z",
    fill: "#BDDDFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 69.6892C133.165 69.9267 132.997 70.2104 132.794 70.332C132.592 70.4478 132.424 70.3551 132.424 70.1177C132.424 69.8803 132.592 69.5966 132.794 69.475C133.003 69.3592 133.165 69.4518 133.165 69.6892Z",
    fill: "#BDDDFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 68.4734C135.272 68.7108 135.105 68.9946 134.902 69.1162C134.699 69.232 134.531 69.1393 134.531 68.9019C134.531 68.6645 134.699 68.3808 134.902 68.2592C135.105 68.1434 135.272 68.236 135.272 68.4734Z",
    fill: "#BDDDFF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 67.2576C137.381 67.495 137.213 67.7787 137.01 67.9003C136.808 68.0162 136.64 67.9235 136.64 67.6861C136.64 67.4487 136.808 67.165 137.01 67.0434C137.213 66.9276 137.381 67.0202 137.381 67.2576Z",
    fill: "#BDDDFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 66.0418C139.488 66.2792 139.32 66.5629 139.118 66.6845C138.915 66.8003 138.747 66.7077 138.747 66.4703C138.747 66.2329 138.915 65.9491 139.118 65.8275C139.32 65.7117 139.488 65.8044 139.488 66.0418Z",
    fill: "#BDDDFF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M137.584 37.1177L106.05 55.4444L74.3125 37.1177L105.847 18.7969L137.584 37.1177Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M137.583 37.1182L137.537 52.1501L106.002 70.4767L106.048 55.4448L137.583 37.1182Z",
    fill: "url(#paint9_linear_0_1)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M106.049 55.4448L106.003 70.4767L74.2656 52.1501L74.3119 37.1182L106.049 55.4448Z",
    fill: "url(#paint10_linear_0_1)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 29.1083L106.065 50.2202L69.4932 29.1083L105.828 7.99072L142.4 29.1083Z",
    fill: "#82BDF9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M142.402 29.1079L142.355 46.427L106.021 67.5446L106.067 50.2197L142.402 29.1079Z",
    fill: "#E3EBFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 38.2109L107.266 50.9151L107.226 65.449L129.125 52.7217V38.2109Z",
    fill: "url(#paint11_linear_0_1)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M130.126 37.6314V52.1422L141.151 45.7322L141.191 31.1982L130.126 37.6314Z",
    fill: "url(#paint12_linear_0_1)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M106.066 50.2202L106.019 67.5451L69.4473 46.4275L69.4936 29.1084L106.066 50.2202Z",
    fill: "#1687CD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M115.555 49.625L110.599 52.4855V53.1629L115.555 50.2967V49.625Z",
    fill: "#BDDDFF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M118.966 47.6562L115.845 49.4571V50.1345L118.966 48.3279V47.6562Z",
    fill: "#BDDDFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M124.119 44.6802L119.255 47.4885V48.166L124.119 45.3519V44.6802Z",
    fill: "#BDDDFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M124.409 44.5119V45.1835L125.312 44.6624V43.9907L124.409 44.5119Z",
    fill: "#BDDDFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M113.268 53.4405C113.268 53.4289 113.268 53.4173 113.274 53.4058L110.599 54.9518V55.6235L113.268 54.0832V53.4405Z",
    fill: "#BDDDFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 53.2375C113.551 53.249 113.551 53.2606 113.551 53.2722V53.9149L120.783 49.74V49.0684L113.551 53.2375Z",
    fill: "#BDDDFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M121.073 48.8952V49.5727L125.312 47.1233V46.4517L121.073 48.8952Z",
    fill: "#BDDDFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.61 53.3594L116.11 54.2221V54.8938L117.61 54.0311V53.3594Z",
    fill: "#BDDDFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.895 53.1917V53.8692L125.312 49.5843V48.9126L117.895 53.1917Z",
    fill: "#BDDDFF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M115.827 54.3901L110.599 57.4069V58.0844L115.827 55.0618V54.3901Z",
    fill: "#BDDDFF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M121.873 53.3594L110.599 59.8678V60.5395L121.867 54.0311C121.867 53.811 121.873 53.5852 121.873 53.3594Z",
    fill: "#BDDDFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 53.1922C122.156 53.418 122.15 53.6439 122.15 53.8697L125.312 52.0457V51.374L122.156 53.1922Z",
    fill: "#BDDDFF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 39.8157C133.165 40.0531 132.997 40.3368 132.794 40.4584C132.592 40.5742 132.424 40.4816 132.424 40.2442C132.424 40.0067 132.592 39.723 132.794 39.6014C133.003 39.4856 133.165 39.5841 133.165 39.8157Z",
    fill: "#BDDDFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 38.6003C135.272 38.8377 135.105 39.1215 134.902 39.2431C134.699 39.3589 134.531 39.2662 134.531 39.0288C134.531 38.7914 134.699 38.5077 134.902 38.3861C135.105 38.2703 135.272 38.3687 135.272 38.6003Z",
    fill: "#BDDDFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 37.384C137.381 37.6214 137.213 37.9052 137.01 38.0268C136.808 38.1426 136.64 38.0499 136.64 37.8125C136.64 37.5751 136.808 37.2914 137.01 37.1698C137.213 37.054 137.381 37.1524 137.381 37.384Z",
    fill: "#BDDDFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 36.1677C139.488 36.4051 139.32 36.6889 139.118 36.8105C138.915 36.9263 138.747 36.8336 138.747 36.5962C138.747 36.3588 138.915 36.0751 139.118 35.9535C139.32 35.8377 139.488 35.9361 139.488 36.1677Z",
    fill: "#BDDDFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 42.1092C133.165 42.3466 132.997 42.6303 132.794 42.7519C132.592 42.8677 132.424 42.7751 132.424 42.5377C132.424 42.3003 132.592 42.0165 132.794 41.8949C133.003 41.7791 133.165 41.8718 133.165 42.1092Z",
    fill: "#BDDDFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 40.8929C135.272 41.1303 135.105 41.414 134.902 41.5356C134.699 41.6514 134.531 41.5588 134.531 41.3214C134.531 41.0839 134.699 40.8002 134.902 40.6786C135.105 40.5628 135.272 40.6555 135.272 40.8929Z",
    fill: "#BDDDFF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 39.677C137.381 39.9144 137.213 40.1982 137.01 40.3198C136.808 40.4356 136.64 40.3429 136.64 40.1055C136.64 39.8681 136.808 39.5844 137.01 39.4628C137.213 39.347 137.381 39.4396 137.381 39.677Z",
    fill: "#BDDDFF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 38.4612C139.488 38.6986 139.32 38.9824 139.118 39.104C138.915 39.2198 138.747 39.1271 138.747 38.8897C138.747 38.6523 138.915 38.3686 139.118 38.247C139.32 38.1312 139.488 38.2238 139.488 38.4612Z",
    fill: "#BDDDFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 44.4017C133.165 44.6391 132.997 44.9228 132.794 45.0444C132.592 45.1602 132.424 45.0676 132.424 44.8301C132.424 44.5927 132.592 44.309 132.794 44.1874C133.003 44.0716 133.165 44.1642 133.165 44.4017Z",
    fill: "#BDDDFF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 43.1858C135.272 43.4232 135.105 43.707 134.902 43.8286C134.699 43.9444 134.531 43.8517 134.531 43.6143C134.531 43.3769 134.699 43.0932 134.902 42.9716C135.105 42.8558 135.272 42.9484 135.272 43.1858Z",
    fill: "#BDDDFF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 41.9695C137.381 42.2069 137.213 42.4907 137.01 42.6123C136.808 42.7281 136.64 42.6354 136.64 42.398C136.64 42.1606 136.808 41.8769 137.01 41.7553C137.213 41.6395 137.381 41.7321 137.381 41.9695Z",
    fill: "#BDDDFF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 40.7537C139.488 40.9911 139.32 41.2748 139.118 41.3964C138.915 41.5122 138.747 41.4196 138.747 41.1822C138.747 40.9448 138.915 40.6611 139.118 40.5395C139.32 40.4237 139.488 40.5163 139.488 40.7537Z",
    fill: "#BDDDFF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M133.165 46.6888C133.165 46.9262 132.997 47.2099 132.794 47.3315C132.592 47.4473 132.424 47.3547 132.424 47.1173C132.424 46.8798 132.592 46.5961 132.794 46.4745C133.003 46.3587 133.165 46.4514 133.165 46.6888Z",
    fill: "#BDDDFF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M135.272 45.4729C135.272 45.7104 135.105 45.9941 134.902 46.1157C134.699 46.2315 134.531 46.1388 134.531 45.9014C134.531 45.664 134.699 45.3803 134.902 45.2587C135.105 45.1429 135.272 45.2355 135.272 45.4729Z",
    fill: "#BDDDFF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M137.381 44.2571C137.381 44.4945 137.213 44.7783 137.01 44.8999C136.808 45.0157 136.64 44.923 136.64 44.6856C136.64 44.4482 136.808 44.1645 137.01 44.0429C137.213 43.9271 137.381 44.0197 137.381 44.2571Z",
    fill: "#BDDDFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M139.488 43.0413C139.488 43.2787 139.32 43.5624 139.118 43.684C138.915 43.7998 138.747 43.7072 138.747 43.4698C138.747 43.2324 138.915 42.9487 139.118 42.8271C139.32 42.7112 139.488 42.8039 139.488 43.0413Z",
    fill: "#BDDDFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M126.101 153.905L122.239 158.312L122.222 166.048L126.078 161.635L126.101 153.905Z",
    fill: "url(#paint13_linear_0_1)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4882 169.921C99.494 169.886 99.494 169.852 99.4998 169.817C99.5056 169.776 99.5114 169.736 99.5172 169.695C99.523 169.66 99.5346 169.626 99.5403 169.585C99.5519 169.545 99.5577 169.504 99.5693 169.469C99.5809 169.435 99.5925 169.4 99.5982 169.359C99.6098 169.319 99.6214 169.278 99.6388 169.244C99.6504 169.209 99.6619 169.174 99.6793 169.139C99.6967 169.099 99.7141 169.058 99.7314 169.018C99.7488 168.983 99.7604 168.948 99.7778 168.914C99.7951 168.873 99.8183 168.832 99.8414 168.792C99.8588 168.757 99.8762 168.728 99.8936 168.693C99.9225 168.647 99.9515 168.595 99.9804 168.549C99.9978 168.52 100.015 168.491 100.038 168.462C100.073 168.41 100.114 168.358 100.154 168.305C100.171 168.282 100.189 168.259 100.206 168.236C100.27 168.155 100.345 168.068 100.42 167.987C100.438 167.964 100.461 167.946 100.478 167.923C100.536 167.86 100.6 167.802 100.664 167.738C100.693 167.709 100.722 167.68 100.751 167.657C100.791 167.622 100.826 167.587 100.866 167.553C100.901 167.524 100.942 167.489 100.982 167.46C101.023 167.425 101.063 167.396 101.11 167.362C101.15 167.333 101.191 167.298 101.231 167.269C101.277 167.234 101.324 167.205 101.37 167.171C101.411 167.142 101.457 167.113 101.503 167.084C101.55 167.055 101.602 167.02 101.654 166.991C101.718 166.951 101.775 166.916 101.845 166.875C102.024 166.771 102.204 166.678 102.395 166.586C102.447 166.563 102.493 166.539 102.546 166.516C102.713 166.435 102.887 166.366 103.067 166.296C103.09 166.285 103.113 166.279 103.136 166.267C103.327 166.192 103.524 166.128 103.721 166.065C103.86 166.024 103.999 165.984 104.138 165.943C104.242 165.914 104.352 165.885 104.456 165.856C104.607 165.821 104.758 165.792 104.908 165.758C105.018 165.735 105.128 165.711 105.238 165.688C105.284 165.682 105.331 165.677 105.377 165.665C105.562 165.636 105.753 165.607 105.945 165.584C105.997 165.578 106.055 165.572 106.107 165.567C106.327 165.543 106.547 165.526 106.767 165.509C106.807 165.509 106.848 165.503 106.888 165.503C107.039 165.497 107.184 165.491 107.334 165.491C107.485 165.491 107.63 165.486 107.78 165.491C107.902 165.491 108.029 165.497 108.151 165.503C108.29 165.509 108.429 165.515 108.562 165.526C108.689 165.532 108.811 165.543 108.938 165.555C109.077 165.567 109.21 165.584 109.344 165.601C109.465 165.619 109.587 165.636 109.708 165.653C109.853 165.677 109.998 165.7 110.143 165.729C110.258 165.752 110.368 165.775 110.478 165.798C110.646 165.833 110.82 165.879 110.982 165.92C111.092 165.949 111.202 165.978 111.306 166.007C111.364 166.024 111.422 166.041 111.48 166.059C111.648 166.111 111.81 166.169 111.972 166.227C112.019 166.244 112.065 166.261 112.117 166.279C112.262 166.337 112.407 166.4 112.551 166.464C112.621 166.493 112.696 166.522 112.76 166.557C112.963 166.655 113.165 166.759 113.356 166.869C114.96 167.796 115.765 169.012 115.759 170.228L115.782 162.498C115.788 161.282 114.983 160.066 113.379 159.139C113.188 159.029 112.986 158.925 112.783 158.827C112.714 158.792 112.644 158.763 112.569 158.734C112.447 158.682 112.326 158.624 112.204 158.572C112.181 158.566 112.158 158.554 112.14 158.549C112.094 158.531 112.048 158.514 111.996 158.497C111.833 158.439 111.671 158.381 111.503 158.329C111.445 158.311 111.388 158.294 111.33 158.277C111.289 158.265 111.254 158.253 111.214 158.242C111.144 158.224 111.075 158.207 111.005 158.19C110.837 158.143 110.67 158.103 110.496 158.068C110.449 158.056 110.409 158.045 110.363 158.033C110.293 158.022 110.229 158.01 110.16 157.999C110.015 157.97 109.87 157.946 109.726 157.923C109.668 157.912 109.61 157.9 109.552 157.894C109.488 157.883 109.425 157.883 109.361 157.871C109.228 157.854 109.089 157.836 108.956 157.825C108.892 157.819 108.828 157.807 108.764 157.802C108.707 157.796 108.643 157.796 108.585 157.79C108.446 157.779 108.307 157.773 108.174 157.767C108.104 157.767 108.035 157.755 107.965 157.755C107.907 157.755 107.855 157.755 107.797 157.755C107.647 157.755 107.502 157.755 107.352 157.755C107.276 157.755 107.201 157.755 107.132 157.755C107.056 157.755 106.981 157.761 106.906 157.767C106.865 157.767 106.825 157.773 106.784 157.773C106.599 157.784 106.414 157.796 106.228 157.813C106.194 157.819 106.159 157.825 106.124 157.825C106.066 157.831 106.014 157.836 105.962 157.842C105.771 157.865 105.586 157.894 105.4 157.923C105.354 157.929 105.308 157.935 105.261 157.946C105.238 157.952 105.215 157.952 105.198 157.958C105.111 157.975 105.024 157.999 104.937 158.016C104.786 158.045 104.636 158.074 104.485 158.114C104.375 158.143 104.271 158.172 104.167 158.201C104.028 158.242 103.883 158.277 103.75 158.323C103.721 158.334 103.692 158.34 103.657 158.346C103.489 158.398 103.327 158.462 103.165 158.52C103.142 158.531 103.119 158.537 103.096 158.549C102.916 158.618 102.742 158.693 102.575 158.769C102.522 158.792 102.476 158.815 102.424 158.838C102.233 158.931 102.053 159.023 101.874 159.128C101.839 159.145 101.804 159.168 101.775 159.186C101.746 159.203 101.718 159.226 101.689 159.244C101.636 159.272 101.59 159.307 101.538 159.336C101.492 159.365 101.451 159.394 101.405 159.423C101.359 159.458 101.312 159.487 101.266 159.521C101.225 159.55 101.185 159.579 101.144 159.614C101.104 159.649 101.057 159.678 101.017 159.713C100.976 159.741 100.942 159.776 100.907 159.805C100.866 159.84 100.826 159.875 100.791 159.909C100.774 159.921 100.756 159.938 100.745 159.95C100.733 159.962 100.716 159.979 100.704 159.99C100.641 160.048 100.577 160.112 100.519 160.176C100.502 160.199 100.478 160.216 100.461 160.239C100.386 160.321 100.316 160.402 100.253 160.488C100.253 160.494 100.247 160.494 100.241 160.5C100.224 160.517 100.212 160.541 100.2 160.558C100.16 160.61 100.119 160.662 100.085 160.714C100.067 160.743 100.044 160.772 100.027 160.801C99.9978 160.847 99.963 160.9 99.9399 160.946C99.9341 160.957 99.9225 160.969 99.9167 160.986C99.9051 161.004 99.8994 161.027 99.8878 161.044C99.8646 161.085 99.8472 161.125 99.8241 161.166C99.8067 161.201 99.7893 161.235 99.7778 161.27C99.7604 161.311 99.743 161.351 99.7256 161.392C99.7198 161.409 99.7083 161.426 99.7025 161.45C99.6967 161.467 99.6909 161.484 99.6851 161.502C99.6735 161.542 99.6562 161.583 99.6446 161.618C99.633 161.652 99.6214 161.687 99.6156 161.728C99.604 161.768 99.5983 161.809 99.5867 161.849C99.5809 161.872 99.5751 161.89 99.5693 161.913C99.5693 161.924 99.5635 161.942 99.5635 161.959C99.5577 162 99.5519 162.04 99.5461 162.081C99.5403 162.116 99.5346 162.15 99.5346 162.185C99.5288 162.226 99.5288 162.266 99.523 162.307C99.523 162.33 99.5172 162.353 99.5172 162.376C99.5172 162.399 99.5172 162.422 99.5172 162.446L99.494 170.176C99.494 170.129 99.4998 170.083 99.4998 170.031C99.4824 170.002 99.4882 169.962 99.4882 169.921Z",
    fill: "url(#paint14_linear_0_1)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M129.749 167.472L121.22 167.727C121.081 167.848 120.936 167.964 120.791 168.08C120.745 168.12 120.693 168.155 120.641 168.19C120.537 168.265 120.438 168.346 120.328 168.422C120.265 168.468 120.201 168.508 120.137 168.555C120.039 168.624 119.94 168.694 119.836 168.757C119.767 168.804 119.697 168.85 119.622 168.891C119.483 168.977 119.35 169.064 119.205 169.145C118.823 169.365 118.429 169.574 118.018 169.771C117.607 169.968 117.184 170.147 116.756 170.315L116.339 175.26L111.295 176.042L106.617 171.89C106.252 171.878 105.887 171.85 105.522 171.826C105.424 171.821 105.319 171.809 105.221 171.803C105.088 171.792 104.955 171.78 104.822 171.763C104.694 171.751 104.567 171.734 104.439 171.722C104.306 171.705 104.173 171.687 104.04 171.67C103.912 171.653 103.791 171.635 103.663 171.618C103.519 171.595 103.38 171.572 103.235 171.548C103.113 171.531 102.992 171.508 102.876 171.485C102.737 171.462 102.592 171.433 102.453 171.404C102.337 171.38 102.222 171.357 102.106 171.334C101.926 171.294 101.741 171.253 101.562 171.213C101.475 171.189 101.382 171.172 101.295 171.149C101.04 171.085 100.786 171.021 100.537 170.946C100.525 170.94 100.513 170.94 100.496 170.935L93.0265 173.147L93.0438 166.638C92.0884 165.521 91.5325 164.316 91.3878 163.094L84.2019 160.402L84.1787 168.132L91.3646 170.825C91.4341 171.421 91.6078 172.012 91.8742 172.596L89.1874 171.045L89.1643 178.775L92.8701 180.917L100.473 178.671H100.479C100.49 178.676 100.502 178.676 100.513 178.676C100.762 178.746 101.017 178.815 101.272 178.879C101.359 178.902 101.452 178.92 101.538 178.943C101.718 178.983 101.897 179.024 102.083 179.064C102.117 179.07 102.152 179.082 102.187 179.088C102.268 179.105 102.349 179.116 102.43 179.134C102.569 179.163 102.714 179.192 102.853 179.215C102.974 179.238 103.09 179.255 103.212 179.279C103.351 179.302 103.496 179.325 103.64 179.348C103.692 179.354 103.739 179.365 103.791 179.371C103.866 179.383 103.941 179.389 104.017 179.4C104.15 179.418 104.283 179.435 104.416 179.452C104.544 179.47 104.671 179.481 104.798 179.493C104.932 179.504 105.065 179.522 105.198 179.533C105.256 179.539 105.308 179.545 105.366 179.551C105.412 179.557 105.458 179.557 105.499 179.557C105.864 179.585 106.229 179.609 106.593 179.62L111.272 183.772L116.315 182.99L116.732 178.045C117.601 177.709 118.417 177.321 119.182 176.876C119.263 176.829 119.338 176.783 119.413 176.737C119.477 176.696 119.535 176.661 119.599 176.621C119.668 176.574 119.743 176.528 119.813 176.488C119.917 176.418 120.016 176.354 120.114 176.285C120.178 176.239 120.241 176.198 120.305 176.152C120.409 176.077 120.514 175.995 120.618 175.92C120.67 175.88 120.722 175.845 120.768 175.804C120.919 175.689 121.058 175.567 121.197 175.451L129.726 175.196L131.064 172.272L131.087 164.542L129.749 167.472Z",
    fill: "url(#paint15_linear_0_1)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M119.204 169.157C118.44 169.603 117.618 169.991 116.755 170.327L116.338 175.272L111.295 176.053L106.616 171.902C104.514 171.82 102.429 171.508 100.501 170.952L92.8984 173.199L89.1926 171.056L93.049 166.644C92.0936 165.526 91.5377 164.322 91.3929 163.1L84.207 160.408L85.5446 157.483L94.0739 157.229C94.6529 156.725 95.3188 156.25 96.0832 155.804C96.8475 155.358 97.6697 154.97 98.5325 154.635L98.9494 149.695L103.993 148.914L108.672 153.065C110.773 153.146 112.858 153.465 114.792 154.015L122.389 151.768L126.095 153.911L122.238 158.323C123.194 159.441 123.75 160.645 123.895 161.861L131.08 164.553L129.743 167.478L121.214 167.732C120.634 168.23 119.969 168.711 119.204 169.157ZM101.903 165.816C105.093 167.657 110.252 167.657 113.425 165.816C116.599 163.974 116.581 160.987 113.391 159.139C110.2 157.298 105.041 157.298 101.868 159.139C98.6946 160.987 98.712 163.974 101.903 165.816Z",
    fill: "url(#paint16_linear_0_1)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M143.604 178.278L141.468 180.716L141.456 185.001L143.593 182.557L143.604 178.278Z",
    fill: "url(#paint17_linear_0_1)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M128.874 187.143C128.874 187.125 128.88 187.102 128.88 187.085C128.885 187.062 128.885 187.038 128.891 187.015C128.897 186.998 128.897 186.975 128.903 186.957C128.909 186.934 128.914 186.911 128.92 186.894C128.926 186.876 128.932 186.853 128.938 186.836C128.943 186.813 128.949 186.79 128.961 186.772C128.967 186.755 128.972 186.732 128.984 186.714C128.995 186.691 129.001 186.668 129.013 186.645C129.019 186.627 129.03 186.604 129.042 186.587C129.053 186.564 129.065 186.541 129.077 186.517C129.088 186.5 129.094 186.483 129.106 186.465C129.123 186.436 129.14 186.413 129.158 186.384C129.169 186.367 129.181 186.349 129.187 186.338C129.204 186.309 129.227 186.28 129.25 186.251C129.262 186.239 129.268 186.228 129.279 186.21C129.314 186.164 129.354 186.118 129.395 186.072C129.407 186.06 129.418 186.048 129.43 186.037C129.465 186.002 129.493 185.967 129.534 185.933C129.551 185.915 129.569 185.904 129.586 185.886C129.609 185.869 129.627 185.846 129.65 185.828C129.673 185.811 129.69 185.794 129.713 185.776C129.737 185.759 129.76 185.741 129.783 185.724C129.806 185.707 129.829 185.689 129.852 185.672C129.876 185.655 129.905 185.637 129.928 185.62C129.951 185.602 129.974 185.585 129.997 185.574C130.026 185.556 130.049 185.539 130.078 185.521C130.113 185.498 130.148 185.481 130.183 185.458C130.281 185.4 130.385 185.348 130.489 185.296C130.518 185.284 130.547 185.267 130.57 185.255C130.663 185.209 130.762 185.168 130.86 185.133C130.872 185.128 130.883 185.122 130.901 185.116C131.005 185.076 131.115 185.041 131.225 185.006C131.3 184.983 131.381 184.96 131.456 184.942C131.514 184.925 131.572 184.908 131.636 184.896C131.717 184.879 131.804 184.861 131.885 184.844C131.943 184.832 132.007 184.815 132.064 184.809C132.088 184.803 132.117 184.803 132.14 184.798C132.244 184.78 132.348 184.769 132.452 184.751C132.481 184.746 132.51 184.745 132.545 184.74C132.667 184.728 132.788 184.717 132.91 184.711C132.933 184.711 132.956 184.711 132.979 184.705C133.06 184.699 133.141 184.699 133.228 184.699C133.309 184.699 133.39 184.699 133.477 184.699C133.547 184.699 133.616 184.705 133.686 184.705C133.761 184.711 133.836 184.711 133.917 184.717C133.987 184.722 134.056 184.728 134.126 184.734C134.201 184.74 134.276 184.751 134.352 184.757C134.421 184.763 134.485 184.774 134.554 184.786C134.635 184.798 134.716 184.815 134.792 184.827C134.855 184.838 134.919 184.85 134.977 184.867C135.07 184.89 135.162 184.913 135.255 184.937C135.313 184.954 135.377 184.966 135.434 184.983C135.469 184.994 135.498 185 135.527 185.012C135.62 185.041 135.712 185.07 135.799 185.105C135.828 185.116 135.851 185.122 135.88 185.133C135.961 185.162 136.042 185.197 136.118 185.238C136.158 185.255 136.199 185.272 136.234 185.29C136.349 185.342 136.459 185.4 136.564 185.464C137.455 185.979 137.895 186.651 137.895 187.322L137.907 183.043C137.907 182.371 137.467 181.694 136.575 181.184C136.471 181.121 136.361 181.063 136.245 181.011C136.205 180.993 136.164 180.976 136.129 180.959C136.06 180.93 135.996 180.895 135.927 180.872C135.915 180.866 135.903 180.866 135.892 180.86C135.869 180.849 135.84 180.843 135.811 180.831C135.718 180.796 135.631 180.767 135.539 180.739C135.51 180.727 135.475 180.721 135.446 180.71C135.423 180.704 135.405 180.698 135.382 180.692C135.342 180.681 135.307 180.675 135.267 180.663C135.174 180.64 135.081 180.617 134.989 180.594C134.965 180.588 134.936 180.582 134.913 180.576C134.879 180.571 134.838 180.565 134.803 180.559C134.722 180.542 134.647 180.53 134.566 180.518C134.531 180.513 134.502 180.507 134.467 180.501C134.433 180.495 134.398 180.495 134.363 180.49C134.288 180.478 134.213 180.472 134.137 180.466C134.103 180.461 134.068 180.455 134.027 180.455C133.993 180.455 133.958 180.449 133.929 180.449C133.854 180.443 133.778 180.437 133.697 180.437C133.657 180.437 133.622 180.432 133.581 180.432C133.553 180.432 133.518 180.432 133.489 180.432C133.408 180.432 133.327 180.432 133.24 180.432C133.199 180.432 133.159 180.432 133.118 180.432C133.078 180.432 133.037 180.437 132.991 180.437C132.968 180.437 132.945 180.437 132.921 180.443C132.817 180.449 132.719 180.455 132.614 180.466C132.597 180.466 132.574 180.472 132.557 180.472C132.528 180.478 132.499 180.478 132.464 180.484C132.36 180.495 132.255 180.513 132.151 180.53C132.128 180.536 132.099 180.536 132.076 180.542C132.064 180.542 132.053 180.547 132.041 180.547C131.995 180.559 131.943 180.571 131.896 180.576C131.815 180.594 131.729 180.611 131.647 180.629C131.59 180.646 131.532 180.657 131.468 180.675C131.393 180.698 131.312 180.715 131.236 180.739C131.219 180.744 131.202 180.75 131.184 180.75C131.092 180.779 130.999 180.814 130.912 180.849C130.901 180.854 130.889 180.86 130.872 180.866C130.773 180.906 130.675 180.947 130.582 180.988C130.553 180.999 130.524 181.011 130.501 181.028C130.397 181.08 130.293 181.132 130.194 181.19C130.177 181.202 130.159 181.213 130.136 181.225C130.119 181.237 130.101 181.248 130.084 181.254C130.055 181.271 130.026 181.289 130.003 181.306C129.98 181.323 129.957 181.341 129.934 181.352C129.91 181.37 129.881 181.387 129.858 181.404C129.835 181.422 129.812 181.439 129.789 181.457C129.766 181.474 129.742 181.491 129.719 181.514C129.696 181.532 129.679 181.549 129.656 181.567C129.632 181.584 129.609 181.607 129.592 181.624C129.58 181.63 129.575 181.642 129.563 181.648C129.557 181.653 129.546 181.665 129.54 181.671C129.505 181.706 129.47 181.74 129.436 181.775C129.424 181.787 129.412 181.798 129.401 181.81C129.36 181.856 129.32 181.902 129.285 181.949L129.279 181.955C129.273 181.966 129.262 181.978 129.256 181.989C129.233 182.018 129.21 182.047 129.192 182.076C129.181 182.093 129.169 182.111 129.163 182.122C129.146 182.151 129.129 182.175 129.111 182.204C129.106 182.209 129.1 182.215 129.1 182.227C129.094 182.238 129.088 182.25 129.082 182.261C129.071 182.285 129.059 182.308 129.048 182.331C129.036 182.348 129.03 182.371 129.019 182.389C129.007 182.412 129.001 182.435 128.99 182.458C128.984 182.47 128.978 182.481 128.978 182.487C128.972 182.499 128.972 182.505 128.967 182.516C128.961 182.539 128.949 182.563 128.943 182.58C128.938 182.597 128.932 182.62 128.926 182.638C128.92 182.661 128.914 182.684 128.909 182.701C128.909 182.713 128.903 182.725 128.903 182.736C128.903 182.742 128.903 182.754 128.897 182.759C128.891 182.783 128.891 182.806 128.885 182.829C128.885 182.846 128.88 182.869 128.88 182.887C128.88 182.91 128.874 182.933 128.874 182.956C128.874 182.968 128.874 182.985 128.874 182.997C128.874 183.008 128.874 183.026 128.874 183.037L128.862 187.316C128.862 187.287 128.862 187.264 128.868 187.235C128.868 187.189 128.874 187.166 128.874 187.143Z",
    fill: "url(#paint18_linear_0_1)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M145.625 185.788L140.906 185.927C140.831 185.991 140.75 186.06 140.669 186.124C140.64 186.147 140.617 186.164 140.588 186.187C140.53 186.228 140.472 186.274 140.414 186.315C140.379 186.338 140.345 186.361 140.31 186.39C140.252 186.431 140.2 186.465 140.142 186.506C140.101 186.529 140.061 186.558 140.026 186.581C139.951 186.628 139.876 186.674 139.794 186.72C139.58 186.842 139.366 186.958 139.134 187.068C138.909 187.178 138.677 187.276 138.434 187.369L138.202 190.108L135.411 190.542L132.823 188.243C132.62 188.237 132.418 188.22 132.215 188.208C132.157 188.203 132.105 188.203 132.047 188.197C131.972 188.191 131.896 188.185 131.827 188.174C131.757 188.168 131.682 188.156 131.613 188.15C131.537 188.139 131.468 188.133 131.393 188.121C131.323 188.11 131.254 188.104 131.184 188.093C131.103 188.081 131.028 188.069 130.947 188.058C130.877 188.046 130.814 188.035 130.744 188.023C130.663 188.011 130.588 187.994 130.512 187.977C130.449 187.965 130.385 187.954 130.321 187.936C130.223 187.913 130.119 187.89 130.02 187.867C129.974 187.855 129.922 187.844 129.876 187.832C129.737 187.797 129.592 187.762 129.459 187.722C129.453 187.722 129.447 187.716 129.435 187.716L125.301 188.938L125.313 185.336C124.78 184.717 124.479 184.051 124.398 183.373L120.42 181.879L120.408 186.159L124.386 187.652C124.427 187.982 124.519 188.313 124.67 188.631L123.182 187.774L123.17 192.053L125.22 193.24L129.43 191.995C129.43 191.995 129.43 191.995 129.435 191.995C129.441 191.995 129.447 192.001 129.453 192.001C129.592 192.042 129.731 192.076 129.87 192.111C129.916 192.123 129.968 192.134 130.014 192.146C130.113 192.169 130.211 192.192 130.316 192.215C130.333 192.221 130.356 192.227 130.373 192.227C130.42 192.238 130.466 192.244 130.507 192.25C130.582 192.267 130.663 192.279 130.738 192.296C130.802 192.308 130.871 192.32 130.935 192.331C131.016 192.343 131.092 192.354 131.173 192.366C131.202 192.372 131.23 192.377 131.254 192.377C131.294 192.383 131.335 192.389 131.381 192.395C131.456 192.406 131.526 192.412 131.601 192.424C131.671 192.43 131.74 192.441 131.815 192.447C131.891 192.453 131.966 192.464 132.035 192.47C132.064 192.47 132.099 192.476 132.128 192.482C132.151 192.482 132.18 192.482 132.203 192.487C132.406 192.505 132.609 192.516 132.811 192.522L135.4 194.821L138.191 194.387L138.422 191.648C138.903 191.463 139.354 191.248 139.777 190.999C139.823 190.976 139.864 190.947 139.905 190.924C139.939 190.901 139.974 190.883 140.003 190.86C140.043 190.837 140.084 190.808 140.119 190.785C140.177 190.75 140.229 190.71 140.287 190.675C140.321 190.652 140.356 190.629 140.391 190.6C140.449 190.559 140.507 190.513 140.565 190.472C140.594 190.449 140.623 190.432 140.646 190.409C140.727 190.345 140.808 190.281 140.883 190.212L145.602 190.073L146.343 188.452L146.355 184.172L145.625 185.788Z",
    fill: "url(#paint19_linear_0_1)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M139.789 186.72C139.366 186.963 138.909 187.183 138.434 187.368L138.202 190.107L135.411 190.542L132.823 188.243C131.659 188.196 130.507 188.023 129.436 187.716L125.226 188.961L123.176 187.774L125.313 185.33C124.78 184.711 124.479 184.045 124.398 183.367L120.42 181.873L121.161 180.252L125.886 180.107C126.205 179.829 126.575 179.563 126.998 179.32C127.421 179.077 127.878 178.857 128.353 178.671L128.584 175.938L131.375 175.504L133.964 177.803C135.128 177.849 136.28 178.023 137.351 178.33L141.555 177.085L143.605 178.272L141.468 180.715C142.001 181.335 142.302 182.001 142.383 182.672L146.361 184.166L145.62 185.788L140.901 185.927C140.582 186.21 140.212 186.477 139.789 186.72ZM130.211 184.873C131.978 185.892 134.832 185.892 136.593 184.873C138.347 183.854 138.341 182.198 136.569 181.179C134.803 180.159 131.949 180.159 130.188 181.179C128.434 182.198 128.44 183.854 130.211 184.873Z",
    fill: "url(#paint20_linear_0_1)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1318 149.663L94.2176 154.869L100.002 158.233L93.9165 153.027L88.1318 149.663Z",
    fill: "url(#paint21_linear_0_1)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M113.176 110.079C112.371 109.61 111.253 109.68 110.02 110.386L83.9629 125.43C81.5136 126.843 79.5333 130.271 79.5391 133.085L79.5854 149.483C79.5912 150.884 80.0834 151.869 80.8767 152.332L86.6671 155.696C85.868 155.233 85.3758 154.249 85.3758 152.847L85.3295 136.449C85.3237 133.635 87.2982 130.207 89.7534 128.794L115.81 113.751C117.044 113.038 118.161 112.975 118.966 113.444L113.176 110.079Z",
    fill: "url(#paint22_linear_0_1)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M115.806 113.75C118.255 112.337 120.247 113.467 120.253 116.286L120.299 132.685C120.305 135.499 118.33 138.933 115.881 140.346L99.9749 149.529L99.998 158.232L93.9123 153.027L89.8185 155.389C87.3692 156.802 85.3772 155.667 85.3657 152.853L85.3193 136.454C85.3136 133.64 87.2881 130.212 89.7432 128.8L115.806 113.75Z",
    fill: "#82BDF9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6063 139.147C94.6063 140.218 93.8536 141.521 92.9213 142.059C91.9891 142.598 91.2363 142.169 91.2363 141.098C91.2363 140.027 91.9891 138.724 92.9213 138.186C93.8536 137.647 94.6063 138.076 94.6063 139.147Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 135.424C101.052 136.495 100.299 137.798 99.3666 138.336C98.4344 138.875 97.6816 138.446 97.6816 137.375C97.6816 136.304 98.4344 135.001 99.3666 134.462C100.299 133.924 101.052 134.358 101.052 135.424Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M107.495 131.706C107.495 132.777 106.742 134.08 105.81 134.618C104.878 135.157 104.125 134.728 104.125 133.657C104.125 132.586 104.878 131.283 105.81 130.745C106.736 130.206 107.495 130.635 107.495 131.706Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M113.939 127.983C113.939 129.054 113.187 130.357 112.254 130.895C111.322 131.434 110.569 131.005 110.569 129.934C110.569 128.863 111.322 127.56 112.254 127.021C113.181 126.483 113.939 126.917 113.939 127.983Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M248.304 83.1821L248.281 90.6865C248.269 94.0044 246.092 97.3223 241.732 99.8527C232.959 104.948 218.692 104.948 209.861 99.8527C205.42 97.2875 203.202 93.9233 203.208 90.5591L203.231 83.0547C203.22 86.4189 205.443 89.7831 209.884 92.3483C218.715 97.4439 232.982 97.4439 241.755 92.3483C246.115 89.8179 248.298 86.5 248.304 83.1821Z",
    fill: "url(#paint23_linear_0_1)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M241.649 73.8895C250.479 78.9851 250.526 87.2538 241.753 92.3494C232.981 97.4449 218.713 97.4449 209.883 92.3494C201.052 87.2538 201.006 78.9851 209.779 73.8895C218.557 68.794 232.824 68.794 241.649 73.8895Z",
    fill: "url(#paint24_linear_0_1)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M212.876 211.502L191.735 223.784C190.264 224.641 187.879 224.641 186.396 223.784L144.723 199.678C143.976 199.25 143.605 198.682 143.605 198.121L143.594 201.213C143.594 201.774 143.964 202.342 144.711 202.77L186.385 226.876C187.867 227.733 190.253 227.727 191.724 226.876L212.864 214.594C213.594 214.172 213.959 213.616 213.965 213.06L213.976 209.968C213.97 210.524 213.606 211.074 212.876 211.502Z",
    fill: "url(#paint25_linear_0_1)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M212.858 208.41C214.341 209.267 214.346 210.645 212.876 211.502L191.735 223.784C190.264 224.641 187.878 224.641 186.396 223.784L144.723 199.678C143.24 198.821 143.234 197.437 144.705 196.586L165.846 184.305C167.317 183.448 169.702 183.453 171.185 184.305L212.858 208.41Z",
    fill: "url(#paint26_linear_0_1)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M210.005 208.214L170.914 185.753C169.599 184.994 167.48 184.994 166.171 185.753L163.369 187.38L163.705 187.75C164.093 188.179 163.983 188.85 163.49 189.134L155.917 193.506C155.702 193.627 155.442 193.662 155.204 193.587L153.543 193.083L147.405 196.65C146.096 197.409 146.108 198.642 147.422 199.401L186.513 221.862C187.828 222.62 189.947 222.62 191.255 221.862L210.028 210.952C211.331 210.2 211.319 208.972 210.005 208.214Z",
    fill: "url(#paint27_linear_0_1)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M171.729 98.5616L170.113 64.9946",
    stroke: "#0B54AC",
    strokeWidth: 1.8707,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M189.604 41.3879C188.046 40.4846 185.892 40.612 183.512 41.9843C183.113 42.2159 182.719 42.4765 182.337 42.7602L185.388 44.5321C185.771 44.2483 186.164 43.9878 186.564 43.7562C188.944 42.3838 191.098 42.2564 192.655 43.1597L189.604 41.3879Z",
    fill: "url(#paint28_linear_0_1)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M179.883 36.3268C178.325 35.4235 176.171 35.5509 173.791 36.9233C169.634 39.3205 166.177 44.7287 165.418 49.6911C164.961 49.8764 164.497 50.108 164.023 50.3802C161.313 51.9436 158.858 54.6245 157.092 57.6992C156.339 57.7398 155.505 58.0061 154.625 58.5099C151.319 60.4207 148.643 65.0473 148.649 68.8516C148.655 70.2818 149.037 71.3878 149.691 72.1174C148.973 73.5013 148.533 75.001 148.539 76.3733C148.545 77.8788 149.078 78.9443 149.935 79.4422L152.986 81.2141C152.129 80.7161 151.596 79.6565 151.591 78.1452C151.585 76.7729 152.025 75.2731 152.743 73.8892C152.089 73.1654 151.706 72.0537 151.701 70.6234C151.689 66.8191 154.364 62.1926 157.676 60.2818C158.557 59.7722 159.39 59.5116 160.143 59.4711C161.909 56.4022 164.364 53.7212 167.074 52.152C167.549 51.8799 168.012 51.6483 168.47 51.463C169.234 46.5006 172.685 41.0981 176.843 38.6951C179.222 37.3228 181.377 37.1954 182.934 38.0987L179.883 36.3268Z",
    fill: "url(#paint29_linear_0_1)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M176.849 38.7011C181.574 35.9738 185.419 38.1626 185.436 43.594C185.436 43.9067 185.419 44.2136 185.395 44.532C185.778 44.2483 186.171 43.9877 186.571 43.7561C191.296 41.0288 195.141 43.2176 195.158 48.649C195.175 54.0804 191.354 60.6931 186.629 63.4262L156.397 80.8784C153.757 82.4013 151.608 81.1795 151.597 78.1454C151.591 76.773 152.031 75.2733 152.749 73.8894C152.095 73.1656 151.713 72.0539 151.707 70.6236C151.695 66.8193 154.37 62.1928 157.682 60.282C158.563 59.7724 159.396 59.5118 160.149 59.4713C161.915 56.4024 164.37 53.7214 167.08 52.1522C167.555 51.8801 168.018 51.6485 168.476 51.4632C169.234 46.5066 172.691 41.0983 176.849 38.7011Z",
    fill: "#AED6FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M197.536 44.2541C196.222 43.4898 194.404 43.5998 192.4 44.7579C192.064 44.9489 191.734 45.1748 191.41 45.4122L193.987 46.9119C194.311 46.6745 194.641 46.4544 194.977 46.2576C196.986 45.0995 198.805 44.9895 200.113 45.7538L197.536 44.2541Z",
    fill: "url(#paint30_linear_0_1)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M189.332 39.986C188.017 39.2217 186.199 39.3317 184.195 40.4898C180.687 42.5164 177.774 47.0735 177.131 51.2599C176.743 51.4163 176.355 51.6132 175.956 51.839C173.669 53.1592 171.601 55.4232 170.107 58.0116C169.47 58.0463 168.764 58.2663 168.023 58.6948C165.232 60.3046 162.974 64.2131 162.985 67.421C162.991 68.6254 163.315 69.5634 163.865 70.1772C163.257 71.3411 162.893 72.6092 162.893 73.7673C162.898 75.0412 163.344 75.9329 164.068 76.3556L166.645 77.8553C165.921 77.4326 165.469 76.5409 165.469 75.267C165.464 74.1089 165.834 72.8408 166.442 71.6769C165.892 71.0631 165.568 70.1309 165.562 68.9207C165.55 65.7128 167.809 61.8043 170.6 60.1945C171.341 59.7661 172.047 59.546 172.684 59.5113C174.178 56.923 176.245 54.6589 178.532 53.3387C178.932 53.1071 179.326 52.916 179.708 52.7597C180.351 48.5732 183.263 44.0104 186.772 41.9895C188.776 40.8314 190.6 40.7214 191.908 41.4857L189.332 39.986Z",
    fill: "url(#paint31_linear_0_1)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M186.766 41.9845C190.75 39.6857 193.998 41.5329 194.01 46.1131C194.01 46.3736 193.998 46.64 193.975 46.9064C194.299 46.669 194.629 46.4489 194.965 46.2521C198.955 43.9475 202.197 45.8004 202.209 50.3806C202.22 54.9666 199.001 60.5428 195.011 62.8474L169.505 77.5724C167.275 78.8579 165.463 77.8272 165.457 75.2678C165.451 74.1097 165.822 72.8416 166.43 71.6777C165.88 71.064 165.556 70.1317 165.55 68.9215C165.538 65.7136 167.796 61.8051 170.587 60.1954C171.329 59.7669 172.035 59.5468 172.672 59.5121C174.166 56.9238 176.233 54.6597 178.52 53.3395C178.92 53.1079 179.314 52.9168 179.696 52.7605C180.344 48.574 183.263 44.0112 186.766 41.9845Z",
    fill: "#AED6FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M234.515 154.391L284.805 125.358C286.137 124.588 287.231 122.504 287.231 120.726V80.4074C287.231 78.6297 286.142 77.8017 284.805 78.5718L234.515 107.605C233.183 108.375 232.089 110.46 232.089 112.237V152.556C232.089 154.339 233.183 155.162 234.515 154.391Z",
    fill: "url(#paint32_linear_0_1)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M234.706 107.495L284.614 78.6816C286.05 77.8536 287.225 78.5195 287.225 80.1697V85.1437L232.089 116.979V112.005C232.089 110.355 233.27 108.328 234.706 107.495Z",
    fill: "url(#paint33_linear_0_1)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M280.825 84.8076C280.825 85.4329 281.265 85.6877 281.815 85.3692C282.36 85.0565 282.806 84.2922 282.806 83.6668C282.806 83.0415 282.365 82.7867 281.815 83.1052C281.265 83.4179 280.825 84.1822 280.825 84.8076Z",
    fill: "#BDDDFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M276.836 87.1122C276.836 87.7376 277.276 87.9924 277.826 87.6739C278.37 87.3612 278.816 86.5969 278.816 85.9715C278.816 85.3462 278.376 85.0914 277.826 85.4099C277.276 85.7225 276.836 86.4869 276.836 87.1122Z",
    fill: "#BDDDFF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M272.847 89.4164C272.847 90.0418 273.287 90.2966 273.837 89.9781C274.381 89.6654 274.827 88.9011 274.827 88.2757C274.827 87.6504 274.387 87.3956 273.837 87.7141C273.287 88.0267 272.847 88.7911 272.847 89.4164Z",
    fill: "#BDDDFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M238.355 147.779L283.12 120.992C283.966 120.506 284.661 119.18 284.661 118.051V92.4745C284.661 91.3453 283.966 90.8242 283.12 91.3106L238.355 118.097C237.509 118.583 236.814 119.909 236.814 121.039V146.615C236.814 147.744 237.509 148.271 238.355 147.779Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M208.985 188.791L270.497 153.041L308.65 175.062L247.133 210.812L208.985 188.791Z",
    fill: "url(#paint34_linear_0_1)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M247.132 210.812L308.649 175.062L308.637 178.241L247.12 213.991L247.132 210.812Z",
    fill: "#0F469D"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M209.106 143.79L208.985 188.793L247.132 210.814L247.12 213.992L206.211 190.373L206.344 142.191L209.106 143.79Z",
    fill: "url(#paint35_linear_0_1)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M209.107 143.788L270.624 108.038L270.497 153.041L208.985 188.791L209.107 143.788Z",
    fill: "#BDDDFF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M211.052 144.912L268.667 111.432L268.557 151.918L210.942 185.398L211.052 144.912Z",
    fill: "url(#paint36_linear_0_1)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M206.344 142.19L267.861 106.446L270.623 108.038L209.106 143.788L206.344 142.19Z",
    fill: "#0F469D"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M219.716 187.293L217.15 188.775L219.727 190.263L222.292 188.781L219.716 187.293Z",
    fill: "url(#paint37_linear_0_1)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M223.336 188.178L225.901 186.696L223.324 185.208L220.759 186.69L223.336 188.178Z",
    fill: "url(#paint38_linear_0_1)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M226.942 186.095L229.507 184.618L226.93 183.13L224.365 184.606L226.942 186.095Z",
    fill: "url(#paint39_linear_0_1)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M230.55 184.015L233.116 182.533L230.539 181.045L227.974 182.521L230.55 184.015Z",
    fill: "url(#paint40_linear_0_1)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M234.145 178.96L231.58 180.442L234.163 181.93L236.722 180.448L234.145 178.96Z",
    fill: "url(#paint41_linear_0_1)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M237.754 176.876L235.188 178.358L237.771 179.846L240.33 178.37L237.754 176.876Z",
    fill: "url(#paint42_linear_0_1)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M241.36 174.797L238.795 176.273L241.377 177.762L243.937 176.285L241.36 174.797Z",
    fill: "url(#paint43_linear_0_1)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M244.968 172.712L242.403 174.195L244.986 175.683L247.545 174.201L244.968 172.712Z",
    fill: "url(#paint44_linear_0_1)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M248.575 170.628L246.01 172.11L248.592 173.598L251.152 172.116L248.575 170.628Z",
    fill: "url(#paint45_linear_0_1)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M252.182 168.549L249.617 170.026L252.2 171.514L254.759 170.037L252.182 168.549Z",
    fill: "url(#paint46_linear_0_1)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M255.808 169.435L258.373 167.952L255.791 166.464L253.226 167.941L255.808 169.435Z",
    fill: "url(#paint47_linear_0_1)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M259.415 167.351L261.98 165.869L259.397 164.38L256.832 165.863L259.415 167.351Z",
    fill: "url(#paint48_linear_0_1)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M263.023 165.266L265.588 163.79L263.006 162.296L260.44 163.778L263.023 165.266Z",
    fill: "url(#paint49_linear_0_1)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M266.629 163.181L269.195 161.704L266.612 160.216L264.053 161.693L266.629 163.181Z",
    fill: "url(#paint50_linear_0_1)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 159.615L270.238 161.103L272.803 159.62L270.22 158.132L267.661 159.615Z",
    fill: "url(#paint51_linear_0_1)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M227.422 190.541L229.988 189.059L227.405 187.571L224.846 189.047L227.422 190.541Z",
    fill: "url(#paint52_linear_0_1)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M231.031 188.457L233.596 186.974L231.019 185.486L228.454 186.969L231.031 188.457Z",
    fill: "url(#paint53_linear_0_1)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M234.638 186.372L237.203 184.895L234.627 183.401L232.062 184.884L234.638 186.372Z",
    fill: "url(#paint54_linear_0_1)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M238.233 181.323L235.668 182.799L238.245 184.287L240.81 182.811L238.233 181.323Z",
    fill: "url(#paint55_linear_0_1)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M241.842 179.238L239.276 180.721L241.853 182.209L244.418 180.726L241.842 179.238Z",
    fill: "url(#paint56_linear_0_1)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M245.448 177.154L242.883 178.636L245.465 180.124L248.025 178.642L245.448 177.154Z",
    fill: "url(#paint57_linear_0_1)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M249.056 175.069L246.491 176.552L249.074 178.04L251.633 176.563L249.056 175.069Z",
    fill: "url(#paint58_linear_0_1)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M252.663 172.991L250.098 174.467L252.68 175.961L255.24 174.479L252.663 172.991Z",
    fill: "url(#paint59_linear_0_1)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M256.27 170.906L253.705 172.388L256.288 173.876L258.847 172.394L256.27 170.906Z",
    fill: "url(#paint60_linear_0_1)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M259.895 171.792L262.454 170.316L259.878 168.822L257.312 170.304L259.895 171.792Z",
    fill: "url(#paint61_linear_0_1)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M263.502 169.707L266.062 168.231L263.485 166.743L260.92 168.219L263.502 169.707Z",
    fill: "url(#paint62_linear_0_1)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M267.11 167.629L269.675 166.146L267.092 164.658L264.527 166.135L267.11 167.629Z",
    fill: "url(#paint63_linear_0_1)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M270.717 165.544L273.282 164.062L270.7 162.574L268.135 164.056L270.717 165.544Z",
    fill: "url(#paint64_linear_0_1)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M274.326 163.46L276.891 161.984L274.308 160.49L271.743 161.972L274.326 163.46Z",
    fill: "url(#paint65_linear_0_1)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M228.934 191.41L227.886 192.012L223.798 189.655L221.238 191.132L225.326 193.494L226.56 194.207L227.903 194.982L231.51 192.898L233.392 191.815L234.076 191.421L231.493 189.927L230.81 190.327L228.934 191.41Z",
    fill: "url(#paint66_linear_0_1)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M235.119 190.814L237.684 189.337L235.101 187.849L232.542 189.326L235.119 190.814Z",
    fill: "url(#paint67_linear_0_1)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M238.725 188.735L241.29 187.252L238.708 185.764L236.148 187.247L238.725 188.735Z",
    fill: "url(#paint68_linear_0_1)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M242.316 183.68L239.757 185.162L242.334 186.65L244.899 185.168L242.316 183.68Z",
    fill: "url(#paint69_linear_0_1)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M245.929 181.595L243.364 183.078L245.941 184.566L248.506 183.089L245.929 181.595Z",
    fill: "url(#paint70_linear_0_1)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M249.536 179.516L246.971 180.993L249.547 182.487L252.113 181.004L249.536 179.516Z",
    fill: "url(#paint71_linear_0_1)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M253.144 177.432L250.579 178.914L253.156 180.403L255.721 178.92L253.144 177.432Z",
    fill: "url(#paint72_linear_0_1)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M256.751 175.347L254.186 176.83L256.762 178.318L259.327 176.841L256.751 175.347Z",
    fill: "url(#paint73_linear_0_1)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M260.359 173.269L257.794 174.745L260.376 176.233L262.936 174.757L260.359 173.269Z",
    fill: "url(#paint74_linear_0_1)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M263.983 174.155L266.542 172.672L263.966 171.184L261.4 172.661L263.983 174.155Z",
    fill: "url(#paint75_linear_0_1)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M267.591 172.071L270.151 170.588L267.574 169.1L265.009 170.582L267.591 172.071Z",
    fill: "url(#paint76_linear_0_1)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M271.198 169.985L273.757 168.509L271.18 167.015L268.615 168.497L271.198 169.985Z",
    fill: "url(#paint77_linear_0_1)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M274.806 167.907L277.366 166.425L274.789 164.937L272.224 166.413L274.806 167.907Z",
    fill: "url(#paint78_linear_0_1)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M278.413 165.822L280.972 164.34L278.395 162.852L275.83 164.334L278.413 165.822Z",
    fill: "url(#paint79_linear_0_1)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M231.992 197.339L234.557 195.863L231.974 194.375L229.409 195.851L231.992 197.339Z",
    fill: "url(#paint80_linear_0_1)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M235.598 195.261L238.163 193.779L235.581 192.291L233.021 193.767L235.598 195.261Z",
    fill: "url(#paint81_linear_0_1)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M239.207 193.176L241.772 191.694L239.189 190.206L236.63 191.688L239.207 193.176Z",
    fill: "url(#paint82_linear_0_1)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M242.813 191.091L245.378 189.615L242.796 188.121L240.236 189.603L242.813 191.091Z",
    fill: "url(#paint83_linear_0_1)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M246.404 186.042L243.845 187.519L246.421 189.013L248.987 187.531L246.404 186.042Z",
    fill: "url(#paint84_linear_0_1)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M250.011 183.958L247.451 185.44L250.028 186.928L252.593 185.446L250.011 183.958Z",
    fill: "url(#paint85_linear_0_1)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M253.618 181.873L251.059 183.355L253.635 184.844L256.2 183.361L253.618 181.873Z",
    fill: "url(#paint86_linear_0_1)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M257.231 179.794L254.666 181.271L257.243 182.759L259.808 181.283L257.231 179.794Z",
    fill: "url(#paint87_linear_0_1)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M260.84 177.709L258.274 179.186L260.851 180.68L263.416 179.198L260.84 177.709Z",
    fill: "url(#paint88_linear_0_1)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M264.447 175.625L261.882 177.107L264.459 178.595L267.024 177.113L264.447 175.625Z",
    fill: "url(#paint89_linear_0_1)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M268.066 176.511L270.631 175.035L268.054 173.541L265.489 175.023L268.066 176.511Z",
    fill: "url(#paint90_linear_0_1)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M271.673 174.426L274.239 172.95L271.662 171.461L269.097 172.938L271.673 174.426Z",
    fill: "url(#paint91_linear_0_1)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M275.287 172.347L277.846 170.865L275.269 169.377L272.704 170.859L275.287 172.347Z",
    fill: "url(#paint92_linear_0_1)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M278.894 170.263L281.453 168.781L278.877 167.293L276.312 168.775L278.894 170.263Z",
    fill: "url(#paint93_linear_0_1)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M282.501 168.178L285.061 166.702L282.484 165.213L279.919 166.69L282.501 168.178Z",
    fill: "url(#paint94_linear_0_1)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M236.081 199.701L238.646 198.219L236.063 196.731L233.498 198.213L236.081 199.701Z",
    fill: "url(#paint95_linear_0_1)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M239.687 197.617L242.252 196.14L239.67 194.646L237.104 196.129L239.687 197.617Z",
    fill: "url(#paint96_linear_0_1)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M243.295 195.532L245.861 194.056L243.278 192.567L240.713 194.044L243.295 195.532Z",
    fill: "url(#paint97_linear_0_1)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M246.902 193.454L249.467 191.972L246.884 190.483L244.319 191.966L246.902 193.454Z",
    fill: "url(#paint98_linear_0_1)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M269.577 177.386L268.529 177.988L265.97 179.464L264.922 180.067L262.362 181.549L261.314 182.151L258.755 183.634L257.707 184.236L255.147 185.712L254.099 186.32L251.54 187.797L247.933 189.881L250.509 191.369L254.117 189.285L256.682 187.808L257.724 187.206L260.289 185.724L261.332 185.122L263.897 183.639L264.939 183.037L267.504 181.561L268.546 180.953L271.112 179.476L272.154 178.874L273.439 178.133L274.719 177.391L272.142 175.903L270.857 176.644L269.577 177.386Z",
    fill: "url(#paint99_linear_0_1)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M275.761 176.789L278.326 175.306L275.75 173.818L273.185 175.301L275.761 176.789Z",
    fill: "url(#paint100_linear_0_1)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M279.369 174.704L281.934 173.228L279.357 171.74L276.792 173.216L279.369 174.704Z",
    fill: "url(#paint101_linear_0_1)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M282.976 172.626L285.541 171.144L282.965 169.656L280.399 171.132L282.976 172.626Z",
    fill: "url(#paint102_linear_0_1)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M286.589 170.541L289.149 169.059L286.572 167.571L284.007 169.053L286.589 170.541Z",
    fill: "url(#paint103_linear_0_1)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M286.386 186.013L267.804 196.743C267.277 197.05 266.478 197.079 266.027 196.818L256.293 191.202C255.836 190.941 255.894 190.478 256.42 190.177L275.002 179.447C275.529 179.14 276.328 179.111 276.78 179.372L286.513 184.988C286.971 185.255 286.913 185.712 286.386 186.013Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M179.466 192.413C181.91 193.826 184.354 196.31 186.212 199.524L183.294 201.185C182.234 199.356 180.845 197.943 179.455 197.138C178.059 196.333 176.67 196.136 175.604 196.744L172.709 191.73C174.573 190.659 177.023 191 179.466 192.413Z",
    fill: "url(#paint104_linear_0_1)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M183.838 189.871C181.394 188.458 178.945 188.116 177.075 189.182L172.697 191.724C174.562 190.658 177.011 191 179.46 192.413C181.904 193.826 184.348 196.31 186.206 199.523L190.584 196.981C188.731 193.768 186.287 191.284 183.838 189.871Z",
    fill: "url(#paint105_linear_0_1)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M179.495 181.214C184.44 184.069 189.374 189.084 193.126 195.58L190.208 197.242C187.255 192.129 183.369 188.18 179.478 185.934C175.587 183.687 171.69 183.143 168.719 184.833L165.824 179.819C169.605 177.671 174.556 178.366 179.495 181.214Z",
    fill: "url(#paint106_linear_0_1)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M183.872 178.672C178.927 175.817 173.982 175.128 170.207 177.277L165.829 179.819C169.604 177.67 174.555 178.359 179.494 181.214C184.439 184.069 189.373 189.083 193.125 195.58L197.503 193.038C193.75 186.541 188.817 181.527 183.872 178.672Z",
    fill: "url(#paint107_linear_0_1)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M179.529 170.015C186.97 174.312 194.399 181.863 200.045 191.637L197.126 193.299C192.28 184.903 185.899 178.423 179.512 174.735C173.125 171.046 166.733 170.154 161.851 172.934L158.956 167.919C164.642 164.682 172.089 165.725 179.529 170.015Z",
    fill: "url(#paint108_linear_0_1)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M183.901 167.474C176.46 163.177 169.014 162.141 163.334 165.377L158.956 167.919C164.636 164.683 172.083 165.719 179.524 170.016C186.964 174.312 194.393 181.863 200.039 191.637L204.411 189.095C198.771 179.321 191.342 171.77 183.901 167.474Z",
    fill: "url(#paint109_linear_0_1)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M178.187 200.317C178.806 199.958 179.663 200.01 180.607 200.554C182.489 201.637 184.006 204.272 184 206.431C183.994 207.503 183.618 208.261 183.01 208.614L180.972 209.801C181.58 209.448 181.962 208.69 181.962 207.618C181.968 205.459 180.451 202.83 178.569 201.741C177.625 201.197 176.768 201.145 176.148 201.504L178.187 200.317Z",
    fill: "#447DCF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M178.563 201.742C176.681 200.659 175.152 201.528 175.147 203.688C175.141 205.848 176.658 208.476 178.54 209.565C180.422 210.648 181.95 209.779 181.956 207.619C181.962 205.46 180.445 202.831 178.563 201.742Z",
    fill: "#CED1FB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9877 194.676L91.873 186.448L101.844 188.046L97.9877 194.676Z",
    fill: "url(#paint110_linear_0_1)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M101.845 188.047C101.353 187.757 100.664 187.798 99.9111 188.238C98.4056 189.106 97.1954 191.208 97.2012 192.934C97.2012 193.791 97.5081 194.393 97.9945 194.677L130.612 213.635C130.125 213.351 129.819 212.749 129.819 211.892C129.813 210.166 131.029 208.064 132.528 207.196C133.287 206.761 133.97 206.721 134.462 207.005L101.845 188.047Z",
    fill: "url(#paint111_linear_0_1)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M132.52 207.194C134.02 206.326 135.242 207.021 135.248 208.752C135.254 210.478 134.038 212.579 132.538 213.448C131.032 214.317 129.816 213.616 129.811 211.89C129.805 210.159 131.021 208.057 132.52 207.194Z",
    fill: "url(#paint112_linear_0_1)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6177 186.888L91.873 186.448L93.5349 188.689C94.0502 188.209 94.4324 187.589 94.6177 186.888Z",
    fill: "#0B3362"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M131.775 207.751L99.32 188.654C98.2603 189.534 97.4381 190.982 97.2412 192.325L129.888 211.121C130.108 209.894 130.837 208.602 131.775 207.751Z",
    fill: "url(#paint113_linear_0_1)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M127.096 219.223L96.5634 236.965C95.9033 237.353 94.8205 237.353 94.1546 236.965L53.9402 213.751C53.6044 213.56 53.4365 213.305 53.4365 213.05L53.4307 215.795C53.4307 216.05 53.5986 216.304 53.9344 216.496L94.1488 239.709C94.8147 240.097 95.8975 240.097 96.5576 239.709L127.09 221.968C127.421 221.776 127.583 221.527 127.583 221.273L127.588 218.528C127.588 218.783 127.426 219.032 127.096 219.223Z",
    fill: "#82BDF9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M127.084 217.827C127.75 218.21 127.756 218.835 127.09 219.223L96.5572 236.965C95.8971 237.353 94.8143 237.353 94.1484 236.965L53.9398 213.751C53.2739 213.369 53.2681 212.743 53.934 212.356L84.4669 194.614C85.127 194.226 86.2098 194.226 86.8757 194.614L127.084 217.827Z",
    fill: "url(#paint114_linear_0_1)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1641 201.695L65.5804 217.04L63.9648 216.114L90.5486 200.763L92.1641 201.695Z",
    fill: "#C9DAF8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4542 204.174L69.8705 219.524L68.2607 218.592L94.8445 203.242L96.4542 204.174Z",
    fill: "#C9DAF8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M100.751 206.652L74.1674 222.002L72.5576 221.07L99.1414 205.726L100.751 206.652Z",
    fill: "#C9DAF8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M105.048 209.136L78.4642 224.48L76.8545 223.554L103.438 208.204L105.048 209.136Z",
    fill: "#C9DAF8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M109.344 211.614L82.7601 226.964L81.1445 226.032L107.728 210.682L109.344 211.614Z",
    fill: "#C9DAF8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M113.635 214.093L87.0511 229.443L85.4414 228.511L112.025 213.161L113.635 214.093Z",
    fill: "#C9DAF8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M117.932 216.571L91.348 231.921L89.7383 230.989L116.322 215.645L117.932 216.571Z",
    fill: "#C9DAF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 164.041,
    y1: 51.7931,
    x2: 173.616,
    y2: 150.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 93.7993,
    y1: 72.9422,
    x2: 133.608,
    y2: 112.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 107.621,
    y1: 59.1188,
    x2: 147.43,
    y2: 98.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 74.3113,
    y1: 59.8632,
    x2: 137.582,
    y2: 59.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 94.7663,
    y1: 76.5408,
    x2: 142.287,
    y2: 76.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 69.7661,
    y1: 56.1496,
    x2: 108.768,
    y2: 95.1515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 93.7983,
    y1: 50.1988,
    x2: 133.607,
    y2: 90.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 107.621,
    y1: 36.3754,
    x2: 147.429,
    y2: 76.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 74.3113,
    y1: 37.1189,
    x2: 137.582,
    y2: 37.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 94.7663,
    y1: 53.7969,
    x2: 142.287,
    y2: 53.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 69.7661,
    y1: 33.4058,
    x2: 108.768,
    y2: 72.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 93.7983,
    y1: 27.4534,
    x2: 133.607,
    y2: 67.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_1",
    x1: 107.621,
    y1: 13.63,
    x2: 147.429,
    y2: 53.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_1",
    x1: 122.219,
    y1: 159.975,
    x2: 126.099,
    y2: 159.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_1",
    x1: 99.475,
    y1: 164,
    x2: 115.791,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_1",
    x1: 84.1838,
    y1: 172.097,
    x2: 131.083,
    y2: 172.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_1",
    x1: 84.2051,
    y1: 162.48,
    x2: 131.082,
    y2: 162.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6599DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_1",
    x1: 141.456,
    y1: 181.638,
    x2: 143.604,
    y2: 181.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_1",
    x1: 128.865,
    y1: 183.866,
    x2: 137.898,
    y2: 183.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_1",
    x1: 120.4,
    y1: 188.349,
    x2: 146.363,
    y2: 188.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_0_1",
    x1: 120.412,
    y1: 183.025,
    x2: 146.363,
    y2: 183.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_0_1",
    x1: 88.131,
    y1: 153.947,
    x2: 100.003,
    y2: 153.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_0_1",
    x1: 79.54,
    y1: 132.74,
    x2: 118.962,
    y2: 132.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_0_1",
    x1: 203.216,
    y1: 93.3654,
    x2: 248.305,
    y2: 93.3654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#AED6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D90D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_0_1",
    x1: 203.236,
    y1: 83.1197,
    x2: 248.303,
    y2: 83.1197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_0_1",
    x1: 143.602,
    y1: 212.821,
    x2: 213.973,
    y2: 212.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_0_1",
    x1: 143.61,
    y1: 204.045,
    x2: 213.973,
    y2: 204.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_0_1",
    x1: 146.426,
    y1: 203.809,
    x2: 210.998,
    y2: 203.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_0_1",
    x1: 187.5,
    y1: 2.27835,
    x2: 187.5,
    y2: 93.9371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_0_1",
    x1: 165.741,
    y1: 2.27791,
    x2: 165.741,
    y2: 93.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_0_1",
    x1: 195.757,
    y1: 11.2548,
    x2: 195.757,
    y2: 88.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_0_1",
    x1: 177.397,
    y1: 11.2542,
    x2: 177.397,
    y2: 88.5937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_0_1",
    x1: 296.332,
    y1: 95.3102,
    x2: 243.944,
    y2: 77.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_0_1",
    x1: 263.192,
    y1: 92.5624,
    x2: 220.702,
    y2: 156.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_0_1",
    x1: 208.983,
    y1: 181.927,
    x2: 308.647,
    y2: 181.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F91D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_0_1",
    x1: 206.21,
    y1: 178.094,
    x2: 247.13,
    y2: 178.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_0_1",
    x1: 195.385,
    y1: 106.433,
    x2: 261.189,
    y2: 168.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_0_1",
    x1: 212.946,
    y1: 189.168,
    x2: 222.882,
    y2: 189.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_0_1",
    x1: 216.554,
    y1: 187.085,
    x2: 226.491,
    y2: 187.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_0_1",
    x1: 220.161,
    y1: 185.003,
    x2: 230.098,
    y2: 185.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_0_1",
    x1: 223.77,
    y1: 182.919,
    x2: 233.706,
    y2: 183.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_0_1",
    x1: 227.377,
    y1: 180.836,
    x2: 237.313,
    y2: 181.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_0_1",
    x1: 230.985,
    y1: 178.754,
    x2: 240.922,
    y2: 179.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_0_1",
    x1: 234.592,
    y1: 176.67,
    x2: 244.529,
    y2: 177.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_0_1",
    x1: 238.201,
    y1: 174.587,
    x2: 248.137,
    y2: 175.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_0_1",
    x1: 241.807,
    y1: 172.505,
    x2: 251.744,
    y2: 173.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_0_1",
    x1: 245.415,
    y1: 170.422,
    x2: 255.352,
    y2: 171.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_0_1",
    x1: 249.024,
    y1: 168.339,
    x2: 258.96,
    y2: 169.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_0_1",
    x1: 252.631,
    y1: 166.256,
    x2: 262.567,
    y2: 167.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_0_1",
    x1: 256.239,
    y1: 164.173,
    x2: 266.176,
    y2: 164.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_0_1",
    x1: 259.846,
    y1: 162.09,
    x2: 269.783,
    y2: 162.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_0_1",
    x1: 263.455,
    y1: 160.007,
    x2: 273.391,
    y2: 160.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_0_1",
    x1: 220.641,
    y1: 189.445,
    x2: 230.577,
    y2: 190.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_0_1",
    x1: 224.249,
    y1: 187.362,
    x2: 234.186,
    y2: 188.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_0_1",
    x1: 227.857,
    y1: 185.279,
    x2: 237.794,
    y2: 186.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_0_1",
    x1: 231.464,
    y1: 183.196,
    x2: 241.4,
    y2: 183.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_0_1",
    x1: 235.072,
    y1: 181.113,
    x2: 245.009,
    y2: 181.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_0_1",
    x1: 238.679,
    y1: 179.03,
    x2: 248.616,
    y2: 179.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_0_1",
    x1: 242.288,
    y1: 176.947,
    x2: 252.224,
    y2: 177.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_0_1",
    x1: 245.895,
    y1: 174.865,
    x2: 255.831,
    y2: 175.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_0_1",
    x1: 249.502,
    y1: 172.781,
    x2: 259.439,
    y2: 173.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_0_1",
    x1: 253.11,
    y1: 170.699,
    x2: 263.047,
    y2: 171.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_0_1",
    x1: 256.718,
    y1: 168.616,
    x2: 266.654,
    y2: 169.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_0_1",
    x1: 260.325,
    y1: 166.533,
    x2: 270.262,
    y2: 167.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_0_1",
    x1: 263.933,
    y1: 164.45,
    x2: 273.87,
    y2: 165.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_0_1",
    x1: 267.542,
    y1: 162.368,
    x2: 277.478,
    y2: 163.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_0_1",
    x1: 210.646,
    y1: 193.194,
    x2: 235.488,
    y2: 195.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_0_1",
    x1: 228.336,
    y1: 189.722,
    x2: 238.273,
    y2: 190.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_0_1",
    x1: 231.943,
    y1: 187.639,
    x2: 241.88,
    y2: 188.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_0_1",
    x1: 235.552,
    y1: 185.556,
    x2: 245.488,
    y2: 186.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_0_1",
    x1: 239.16,
    y1: 183.473,
    x2: 249.096,
    y2: 184.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_0_1",
    x1: 242.766,
    y1: 181.39,
    x2: 252.703,
    y2: 182.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_0_1",
    x1: 246.375,
    y1: 179.308,
    x2: 256.311,
    y2: 180.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_0_1",
    x1: 249.982,
    y1: 177.224,
    x2: 259.918,
    y2: 177.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_0_1",
    x1: 253.59,
    y1: 175.141,
    x2: 263.527,
    y2: 175.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_0_1",
    x1: 257.197,
    y1: 173.059,
    x2: 267.134,
    y2: 173.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_0_1",
    x1: 260.806,
    y1: 170.976,
    x2: 270.742,
    y2: 171.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_0_1",
    x1: 264.413,
    y1: 168.892,
    x2: 274.349,
    y2: 169.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_0_1",
    x1: 268.021,
    y1: 166.81,
    x2: 277.958,
    y2: 167.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_0_1",
    x1: 271.628,
    y1: 164.727,
    x2: 281.565,
    y2: 165.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_0_1",
    x1: 225.208,
    y1: 196.247,
    x2: 235.145,
    y2: 196.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_0_1",
    x1: 228.815,
    y1: 194.165,
    x2: 238.751,
    y2: 194.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_0_1",
    x1: 232.424,
    y1: 192.082,
    x2: 242.36,
    y2: 192.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_0_1",
    x1: 236.03,
    y1: 189.998,
    x2: 245.967,
    y2: 190.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_0_1",
    x1: 239.639,
    y1: 187.916,
    x2: 249.576,
    y2: 188.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_0_1",
    x1: 243.246,
    y1: 185.833,
    x2: 253.182,
    y2: 186.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_0_1",
    x1: 246.853,
    y1: 183.75,
    x2: 256.79,
    y2: 184.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_0_1",
    x1: 250.461,
    y1: 181.667,
    x2: 260.398,
    y2: 182.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_0_1",
    x1: 254.07,
    y1: 179.584,
    x2: 264.006,
    y2: 180.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_0_1",
    x1: 257.678,
    y1: 177.501,
    x2: 267.614,
    y2: 178.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_0_1",
    x1: 261.285,
    y1: 175.419,
    x2: 271.222,
    y2: 176.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_0_1",
    x1: 264.893,
    y1: 173.335,
    x2: 274.83,
    y2: 174.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_0_1",
    x1: 268.501,
    y1: 171.252,
    x2: 278.437,
    y2: 172.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_0_1",
    x1: 272.108,
    y1: 169.17,
    x2: 282.045,
    y2: 169.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_0_1",
    x1: 275.716,
    y1: 167.086,
    x2: 285.653,
    y2: 167.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_0_1",
    x1: 229.296,
    y1: 198.607,
    x2: 239.233,
    y2: 199.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_0_1",
    x1: 232.903,
    y1: 196.524,
    x2: 242.84,
    y2: 197.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_0_1",
    x1: 236.512,
    y1: 194.441,
    x2: 246.448,
    y2: 195.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_0_1",
    x1: 240.118,
    y1: 192.359,
    x2: 250.055,
    y2: 193.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_0_1",
    x1: 227.282,
    y1: 185.599,
    x2: 277.209,
    y2: 189.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_0_1",
    x1: 268.98,
    y1: 175.695,
    x2: 278.917,
    y2: 176.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_0_1",
    x1: 272.588,
    y1: 173.612,
    x2: 282.524,
    y2: 174.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_0_1",
    x1: 276.196,
    y1: 171.53,
    x2: 286.132,
    y2: 172.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_0_1",
    x1: 279.803,
    y1: 169.447,
    x2: 289.74,
    y2: 170.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_0_1",
    x1: 172.704,
    y1: 196.143,
    x2: 186.21,
    y2: 196.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_0_1",
    x1: 172.704,
    y1: 194.041,
    x2: 190.585,
    y2: 194.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_0_1",
    x1: 165.831,
    y1: 187.902,
    x2: 193.128,
    y2: 187.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_0_1",
    x1: 165.83,
    y1: 185.8,
    x2: 197.502,
    y2: 185.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_0_1",
    x1: 158.96,
    y1: 179.662,
    x2: 200.043,
    y2: 179.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_0_1",
    x1: 158.96,
    y1: 177.56,
    x2: 204.417,
    y2: 177.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_0_1",
    x1: 90.3687,
    y1: 197.234,
    x2: 112.928,
    y2: 164.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_0_1",
    x1: 121.105,
    y1: 192.556,
    x2: 109.636,
    y2: 208.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0425,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_0_1",
    x1: 129.81,
    y1: 210.318,
    x2: 135.251,
    y2: 210.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_0_1",
    x1: 97.6308,
    y1: 188.577,
    x2: 148.819,
    y2: 223.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_0_1",
    x1: 97.1514,
    y1: 237.827,
    x2: 55.3238,
    y2: 98.9461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0763BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172A7C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaas);
export default __webpack_public_path__ + "static/media/SAAS.959864a7682455bbdb0b515462893794.svg";
export { ForwardRef as ReactComponent };